<template>
    <div class="custom-container">
        <div class="filters-mobile" v-show="show">
            <div class="filters-mobile__header">
                <div class="filters-mobile__title">
                    Filtre
                </div>

                <div class="filters-mobile__reset" @click="resetFilters()">
                    <i class="fad fa-redo"></i>
                        Reseteaza filtre
                    <div class="mobile-filters-counter" v-if="filtersCounter > 0">
                        {{filtersCounter}}
                    </div>
                </div>

                <div class="filters-mobile__close">
                    <i class="fad fa-times-circle" @click="show = false"></i>
                </div>

            </div>
            <div class="filters-mobile__container">
                <div class="filters-mobile__county">
                    Judet - {{county.name}}
                </div>
                <div class="filters-mobile__field-name">
                    Oras
                </div>
                <div class="pill-search">
                        <div class="input-group input-group-tags">
                            <ul class="results-tag-list" id="citiestagList">
                                <li v-for="city in filters.selectedCities" :key="city.id">
                                    <span class="results-tag">
                                    <span> {{ city.name }} </span>
                                    <i
                                        class="fad fa-times-circle"
                                        @click="deleteCity(city)"
                                    ></i>
                                    </span>
                                </li>
                                <li>
                                    <input
                                        type="search"
                                        id="citySearch"
                                        v-model="citySearch"
                                        placeholder="Oras"
                                        autocomplete="none"
                                        @keydown="citiesSearchTrigger('mobile')"
                                        @click="citiesSearchTrigger('mobile')"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div class="search-results-box" id="citySearchResultBoxMobile">
                            <ul class="search-results-list">
                                <li
                                    class="main-result-item"
                                    v-for="city in citiesList"
                                    :key="`city-${city.id}`"
                                >
                                    <div class="search-result-line">
                                        <div class="result-checkbox">
                                            <input
                                                type="checkbox"
                                                class="custom-checkbox"
                                                :id="`city-${city.id}`"
                                                :value="city"
                                                v-model="filters.selectedCities"
                                                @change="changeCities"
                                            />
                                            <label
                                                class="custom-checkbox-label"
                                                :for="`city-${city.id}`"
                                            >
                                                <span></span>
                                                <p>
                                                    {{ city.name }}
                                                </p>
                                            </label>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="search-result-footer">
                                <button
                                    type="button"
                                    name="button"
                                    class="general-btn negative-btn"
                                    @click="closeCitiesResults('mobile')"
                                >
                                    <i class="fad fa-times-circle"></i>
                                    <span> Inchide </span>
                                </button>
                            </div>
                        </div>
                    </div>
                <div class="filters-mobile__field-name">
                    Zona
                </div>
                <div class="pill-search">
                        <div class="input-group input-group-tags">
                            <ul class="results-tag-list" id="areatagList">
                                <li v-for="zone in filters.selectedZones" :key="zone.id">
                                    <span class="results-tag">
                                    <span> {{ zone.name }} </span>
                                    <i
                                        class="fad fa-times-circle"
                                        @click="deleteZone(zone)"
                                    ></i>
                                    </span>
                                </li>
                                <li>
                                    <input
                                        type="search"
                                        id="zonaSearch"
                                        v-model="zoneSearch"
                                        placeholder="Zona"
                                        autocomplete="none"
                                        @keydown="zonesSearchTrigger('mobile')"
                                        @click="zonesSearchTrigger('mobile')"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div class="search-results-box" id="areaResultBoxMobile" v-if="filters.selectedCities.length > 0">
                            <ul class="search-results-list">
                                <li
                                    class="main-result-item"
                                    v-for="zone in zonesList"
                                    :key="`zone-${zone.id}`"
                                >
                                    <div class="search-result-line">
                                        <div class="result-checkbox">
                                            <input
                                                type="checkbox"
                                                v-model="filters.selectedZones"
                                                :value="zone"
                                                class="custom-checkbox"
                                                :id="`zone-${zone.id}`"
                                                @change="changeZones()"
                                            />
                                            <label
                                                :for="`zone-${zone.id}`"
                                                class="custom-checkbox-label"
                                            >
                                                <span></span>
                                                <p>{{ zone.name }} ({{ zone.projectCount }})</p>
                                            </label>
                                        </div>

                                        <button
                                            data-toggle="collapse"
                                            :data-target="'#subzoneList' + zone.id"
                                            aria-expanded="false"
                                            v-if="zone.subzones.length > 0"
                                        >
                                            <i class="fad fa-chevron-circle-down"></i>
                                        </button>
                                    </div>
                                    <ul
                                        :id="'subzoneList' + zone.id"
                                        class="mt-2 collapse results-list-collapse"
                                        v-if="zone.subzones.length > 0"
                                    >
                                        <li
                                            v-for="subzone in zone.subzones"
                                            :key="`subzone-${subzone.id}`"
                                        >
                                            <div class="general-check">
                                                <input
                                                    type="checkbox"
                                                    :id="`subzone-${subzone.id}`"
                                                    v-model="filters.selectedSubzones"
                                                    :value="subzone"
                                                    class="custom-checkbox"
                                                    @change="changeSubzones()"
                                                />
                                                <label
                                                    :for="`subzone-${subzone.id}`"
                                                    class="custom-checkbox-label"
                                                >
                                                    <span></span>
                                                    <p>
                                                        {{ subzone.name }} ({{ subzone.projectCount }})
                                                    </p>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <div class="search-result-footer">
                                <button
                                    type="button"
                                    name="button"
                                    class="general-btn negative-btn"
                                    @click="closeZonesResults('mobile')"
                                >
                                    <i class="fad fa-times-circle"></i>
                                    <span> Inchide </span>
                                </button>
                            </div>
                        </div>
                    </div>
                <div class="filters-mobile__field-name">
                    Tipul proprietatii
                </div>
                <div class="filters-mobile__select-input-container">
                    <div class="filters-mobile__select-input">
                        <input
                            id="house-mobile"
                            type="radio"
                            name="type"
                            value="house"
                            v-model="filters.type"
                            @change="changeType"
                            />
                        <label for="house-mobile" @click="filters.type = 'house'">
                            Case / Vile
                        </label>
                    </div>
                    <div class="filters-mobile__select-input">
                        <input 
                            id="apartment-mobile"
                            type="radio"
                            name="type"
                            value="apartment"
                            v-model="filters.type"
                            @change="changeType"
                            />
                        <label for="apartment-mobile" @click="filters.type = 'apartment'">
                            Apartamente
                        </label>
                    </div>
                    <div class="filters-mobile__select-input">
                        <input
                            id="commercial-mobile"
                            type="radio"
                            name="type"
                            value="commercial"
                            v-model="filters.type"
                            class="card-input-element"
                            @change="changeType"
                        />
                        <label for="commercial-mobile" @click="filters.type = 'commercial'">
                            Spatii
                        </label>
                    </div>
                </div>
                <div class="filters-mobile__row">
                    <div class="filters-mobile__field-name">
                        Nr camere
                    </div>
                    <div class="filters-mobile__room-nr">
                        <div class="filters-mobile__select-input-container">
                            <div
                                class="filters-mobile__select-input"
                                v-for="roomCount in roomsCount.slice(0, roomsCount.length-1)"
                                :key="`mobile-room-${roomCount.id}`"
                            >
                                <input
                                    type="checkbox"
                                    name="roomNumber"
                                    :id="`mobile-room-${roomCount.id}`"
                                    :value="roomCount"
                                    v-model="filters.selectedRoomsCount"
                                    :disabled="isFilterCommercial"
                                    @change="changeRoomsCount"
                                >
                                <label :for="`mobile-room-${roomCount.id}`">
                                    {{ roomCount.name[0] }}
                                </label>
                            </div>
                        </div>
                        <div class="filters-mobile__select-input-container">
                            <div class="filters-mobile__select-input">
                                <input
                                    type="checkbox"
                                    name="roomNumber"
                                    :id="`mobile-room-${roomsCount[roomsCount.length-1].id}`"
                                    :value="roomsCount[roomsCount.length-1]"
                                    v-model="filters.selectedRoomsCount"
                                    :disabled="isFilterCommercial"
                                    @change="changeRoomsCount"
                                >
                                <label :for="`mobile-room-${roomsCount[roomsCount.length-1].id}`">
                                    {{ roomsCount[roomsCount.length-1].name }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filters-mobile__field-name">
                    Pret
                </div>
                <div class="filters-mobile__slider-value" id="filter-price-display">
                    10 000 - {{ priceValuesMax }} &euro;
                </div>
                <veeno
                    connect
                    :set="[filters.minPrice ? filters.minPrice : 0, filters.maxPrice ? filters.maxPrice : priceValuesMax]"
                    :handles="[0, priceValuesMax]"
                    :range="{'min': 0, 'max': priceValuesMax}"
                    :step="1000"
                    class="filters-mobile__slider"
                    @change="changePriceFilter"
                    @update="updatePriceDisplay"></veeno>
                <div class="filters-mobile__field-name">
                    Suprafata
                </div>
                <div class="filters-mobile__slider-value" id="filter-surface-display">
                    0 &#13217; - {{ surfaceValuesMax }} &#13217;
                </div>
                <veeno
                    connect
                    :set="[filters.minSurface ? filters.minSurface : 0, filters.maxSurface ? filters.maxSurface : surfaceValuesMax]"
                    :handles="[0, surfaceValuesMax]"
                    :range="{'min': 0, 'max': surfaceValuesMax}"
                    :step="1"
                    class="filters-mobile__slider"
                    @change="changeSurfaceFilter"
                    @update="updateSurfaceDisplay"></veeno>
                <div class="filters-mobile__check">
                    <div class="singular-check">
                        <input
                            type="checkbox"
                            value="1"
                            id="developerInstallements"
                            class="custom-checkbox"
                            v-model="filters.ratesToDeveloper"
                            @change="changeRatesToDeveloper()"
                        />
                        <label for="developerInstallements" class="custom-checkbox-label">
                            <span></span>
                            Rate la dezvoltator
                        </label>
                    </div>
                </div>
            </div>
            <div class="filters-mobile__footer">
                <div class="filters-mobile__field-results">
                    {{totalFilteredProjects}}
                    {{totalFilteredProjects === 1 ? 'proiect' : 'proiecte'}} 
                    /
                    {{ modelsListingLabel }}
                </div>

                <div class="filters-mobile__button" @click="show = false">
                    Afiseaza
                </div>
            </div>
        </div>
        <!--  -->
        <div class="filters-row">
            <!-- <h4 class="filters-toggle" @click="show = !show">
                Filtre
                <i class="fas fa-sliders-h"></i>
            </h4> -->
            <div class="filters-collapse row" v-show="show">
                <div class="mt-3 col-lg-2 col-md-6 col-12">
                    <div class="filters-header">
                        <h4 class="filters-title">Filtre:</h4>
                        <h5 class="selected-county">
                            <span> județ {{ county.name }} </span>
                        </h5>
                    </div>
                </div>
                <div class="mt-3 col-lg-4 col-md-6 col-12">
                    <div class="pill-search">
                        <div class="input-group input-group-tags">
                            <ul class="results-tag-list" id="citiestagList">
                                <li v-for="city in filters.selectedCities" :key="city.id">
                                    <span class="results-tag">
                                    <span> {{ city.name }} </span>
                                    <i
                                        class="fad fa-times-circle"
                                        @click="deleteCity(city)"
                                    ></i>
                                    </span>
                                </li>
                                <li>
                                    <input
                                        type="search"
                                        id="citySearch"
                                        v-model="citySearch"
                                        placeholder="Oras"
                                        autocomplete="none"
                                        @keydown="citiesSearchTrigger('desktop')"
                                        @click="citiesSearchTrigger('desktop')"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div class="search-results-box" id="citySearchResultBoxDesktop">
                            <ul class="search-results-list">
                                <li
                                    class="main-result-item"
                                    v-for="city in citiesList"
                                    :key="`city-${city.id}`"
                                >
                                    <div class="search-result-line">
                                        <div class="result-checkbox">
                                            <input
                                                type="checkbox"
                                                class="custom-checkbox"
                                                :id="`city-${city.id}`"
                                                :value="city"
                                                v-model="filters.selectedCities"
                                                @change="changeCities"
                                            />
                                            <label
                                                class="custom-checkbox-label"
                                                :for="`city-${city.id}`"
                                            >
                                                <span></span>
                                                <p>
                                                    {{ city.name }}
                                                </p>
                                            </label>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="search-result-footer">
                                <button
                                    type="button"
                                    name="button"
                                    class="general-btn negative-btn"
                                    @click="closeCitiesResults('desktop')"
                                >
                                    <i class="fad fa-times-circle"></i>
                                    <span> Inchide </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-3 col-lg-6 col-md-6 col-12">
                    <div class="pill-search">
                        <div class="input-group input-group-tags">
                            <ul class="results-tag-list" id="areatagList">
                                <li v-for="zone in filters.selectedZones" :key="zone.id">
                                    <span class="results-tag">
                                    <span> {{ zone.name }} </span>
                                    <i
                                        class="fad fa-times-circle"
                                        @click="deleteZone(zone)"
                                    ></i>
                                    </span>
                                </li>
                                <li>
                                    <input
                                        type="search"
                                        id="zonaSearch"
                                        v-model="zoneSearch"
                                        placeholder="Zona"
                                        autocomplete="none"
                                        @keydown="zonesSearchTrigger('desktop')"
                                        @click="zonesSearchTrigger('desktop')"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div class="search-results-box" id="areaResultBoxDesktop">
                            <ul class="search-results-list">
                                <li
                                    class="main-result-item"
                                    v-for="zone in zonesList"
                                    :key="`zone-${zone.id}`"
                                >
                                    <div class="search-result-line">
                                        <div class="result-checkbox">
                                            <input
                                                type="checkbox"
                                                v-model="filters.selectedZones"
                                                :value="zone"
                                                class="custom-checkbox"
                                                :id="`zone-${zone.id}`"
                                                @change="changeZones()"
                                            />
                                            <label
                                                :for="`zone-${zone.id}`"
                                                class="custom-checkbox-label"
                                            >
                                                <span></span>
                                                <p>{{ zone.name }} ({{ zone.projectCount }})</p>
                                            </label>
                                        </div>

                                        <button
                                            data-toggle="collapse"
                                            :data-target="'#subzoneList' + zone.id"
                                            aria-expanded="false"
                                            v-if="zone.subzones.length > 0"
                                        >
                                            <i class="fad fa-chevron-circle-down"></i>
                                        </button>
                                    </div>
                                    <ul
                                        :id="'subzoneList' + zone.id"
                                        class="mt-2 collapse results-list-collapse"
                                        v-if="zone.subzones.length > 0"
                                    >
                                        <li
                                            v-for="subzone in zone.subzones"
                                            :key="`subzone-${subzone.id}`"
                                        >
                                            <div class="general-check">
                                                <input
                                                    type="checkbox"
                                                    :id="`subzone-${subzone.id}`"
                                                    v-model="filters.selectedSubzones"
                                                    :value="subzone"
                                                    class="custom-checkbox"
                                                    @change="changeSubzones()"
                                                />
                                                <label
                                                    :for="`subzone-${subzone.id}`"
                                                    class="custom-checkbox-label"
                                                >
                                                    <span></span>
                                                    <p>
                                                        {{ subzone.name }} ({{ subzone.projectCount }})
                                                    </p>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <div class="search-result-footer">
                                <button
                                    type="button"
                                    name="button"
                                    class="general-btn negative-btn"
                                    @click="closeZonesResults('desktop')"
                                >
                                    <i class="fad fa-times-circle"></i>
                                    <span> Inchide </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-3 col-lg-6 col-md-6 col-12">
                    <div class="modeltype-checkbox-row">
                        <label class="box-radio-card">
                            <input
                                type="radio"
                                name="type"
                                value="house"
                                v-model="filters.type"
                                class="card-input-element"
                                @change="changeType"
                            />
                            <div class="panel panel-default card-input">
                                <i class="fad fa-house"></i>
                                <h2 class="pannel-heading">Case / Vile</h2>
                            </div>
                        </label>
                        <label class="box-radio-card">
                            <input
                                type="radio"
                                name="type"
                                value="apartment"
                                v-model="filters.type"
                                class="card-input-element"
                                @change="changeType"
                            />
                            <div class="panel panel-default card-input">
                                <i class="fad fa-building"></i>
                                <h2 class="pannel-heading">Apartamente</h2>
                            </div>
                        </label>
                        <label class="box-radio-card">
                            <input
                                type="radio"
                                name="type"
                                value="commercial"
                                v-model="filters.type"
                                class="card-input-element"
                                @change="changeType"
                            />
                            <div class="panel panel-default card-input">
                                <i class="fad fa-object-group"></i>
                                <h2 class="pannel-heading">Spaţii</h2>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="mt-3 col-lg-3 col-md-6 col-12">
                    <div class="range-group-wrapper">
                        <h5 class="range-group-title">Suprafața</h5>
                        <div class="surface-range range-group">
                            <div class="input-group">
                                <div :class="{
                                        'range-input-box': true,
                                        'custom-placeholder': true,
                                        'show-placeholder': minSurfaceHasFocusOrValue,
                                     }"
                                     data-placeholder="m²">
                                    <input
                                        type="text"
                                        id="surfaceRangeMin"
                                        v-model="filters.minSurface"
                                        placeholder="Minima"
                                        autocomplete="off"
                                        @change="changeMinSurface"
                                        @click="minSurfaceTrigger()"
                                        @focus="minSurfaceHasFocus = true"
                                        @blur="minSurfaceHasFocus = false"
                                    />
                                </div>
                                <div class="search-results-box" id="minSurfaceResults">
                                    <ul class="search-results-list">
                                        <li
                                            class="main-result-item"
                                            v-for="(surface, index) in filters.surfaceValues"
                                            :key="`minSurface-${index}`"
                                        >
                                            <div class="search-result-line">
                                                <div class="result-radio">
                                                    <div>
                                                        <input
                                                            type="radio"
                                                            @click="
                                                                filters.minSurface = surface;
                                                                changeMinSurface();
                                                                "
                                                            name="min_surface"
                                                            class="custom-radio"
                                                            :id="`minSurface-${index}`"
                                                        />
                                                        <label
                                                            class="custom-radio-label"
                                                            :for="`minSurface-${index}`"
                                                        >
                                                            <span></span>
                                                            <p>
                                                                {{ surface }} m²
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="input-group">
                                <div :class="{
                                        'range-input-box': true,
                                        'custom-placeholder': true,
                                        'show-placeholder': maxSurfaceHasFocusOrValue,
                                     }"
                                     data-placeholder="m²">
                                    <input
                                        type="text"
                                        id="surfaceRangeMax"
                                        v-model="filters.maxSurface"
                                        placeholder="Maxima"
                                        autocomplete="off"
                                        @change="changeMaxSurface"
                                        @click="maxSurfaceTrigger()"
                                        @focus="maxSurfaceHasFocus = true"
                                        @blur="maxSurfaceHasFocus = false"
                                    />
                                </div>
                                <div class="search-results-box" id="maxSurfaceResults">
                                    <ul class="search-results-list">
                                        <li
                                            class="main-result-item"
                                            v-for="(surface, index) in filters.surfaceValues"
                                            :key="`maxSurface-${index}`"
                                        >
                                            <div class="search-result-line">
                                                <div class="result-radio">
                                                    <input
                                                        type="radio"
                                                        @click="
                                                            filters.maxSurface = surface;
                                                            changeMaxSurface();
                                                            "
                                                        name="max_surface"
                                                        class="custom-radio"
                                                        :id="`maxSurface-${index}`"
                                                    />
                                                    <label
                                                        class="custom-radio-label"
                                                        :for="`maxSurface-${index}`"
                                                    >
                                                        <span></span>
                                                        <p>
                                                            {{ surface }} m²
                                                        </p>
                                                    </label>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-3 col-lg-3 col-md-6 col-12">
                    <div class="range-group-wrapper">
                        <h5 class="range-group-title">Preț</h5>
                        <div class="price-range range-group">
                            <div class="input-group">
                                <div :class="{
                                        'range-input-box': true,
                                        'custom-placeholder': true,
                                        'show-placeholder': minPriceHasFocusOrValue,
                                     }"
                                     data-placeholder="€">
                                    <input
                                        type="text"
                                        class="range-input"
                                        v-model="filters.minPrice"
                                        id="priceRangeMin"
                                        @change="changeMinPrice()"
                                        placeholder="Minim"
                                        autocomplete="off"
                                        @click="minPriceTrigger()"
                                        @focus="minPriceHasFocus = true"
                                        @blur="minPriceHasFocus = false"
                                    />
                                </div>
                                <div class="search-results-box extra-large" id="minPriceResults">
                                    <ul class="search-results-list">
                                        <li
                                            class="main-result-item"
                                            v-for="(price, index) in filters.priceValues"
                                            :key="`minPrice-${index}`"
                                        >
                                            <div class="search-result-line">
                                                <div class="result-radio">
                                                    <input
                                                        type="radio"
                                                        @click="
                                                            filters.minPrice = price;
                                                            changeMinPrice();
                                                            "
                                                        name="min_price"
                                                        class="custom-radio"
                                                        :id="`minPrice-${index}`"
                                                    />
                                                    <label
                                                        class="custom-radio-label"
                                                        :for="`minPrice-${index}`"
                                                    >
                                                        <span></span>
                                                        <p>
                                                            {{ price }} €
                                                        </p>
                                                    </label>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="input-group">
                                <div :class="{
                                        'range-input-box': true,
                                        'custom-placeholder': true,
                                        'show-placeholder': maxPriceHasFocusOrValue,
                                     }"
                                     data-placeholder="€">
                                    <input
                                        type="text"
                                        class="range-input"
                                        v-model="filters.maxPrice"
                                        id="priceRangeMax"
                                        @change="changeMaxPrice"
                                        placeholder="Maxim"
                                        autocomplete="off"
                                        @click="maxPriceTrigger()"
                                        @focus="maxPriceHasFocus = true"
                                        @blur="maxPriceHasFocus = false"
                                    />
                                </div>
                                <div class="search-results-box extra-large" id="maxPriceResults">
                                    <ul class="search-results-list">
                                        <li
                                            class="main-result-item"
                                            v-for="(price, index) in filters.priceValues"
                                            :key="`maxPrice-${index}`"
                                        >
                                            <div class="search-result-line">
                                                <div class="result-radio">
                                                    <input
                                                        type="radio"
                                                        @click="
                                                            filters.maxPrice = price;
                                                            changeMaxPrice();
                                                            "
                                                        name="max_price"
                                                        class="custom-radio"
                                                        :id="`maxPrice-${index}`"
                                                    />
                                                    <label
                                                        class="custom-radio-label"
                                                        :for="`maxPrice-${index}`"
                                                    >
                                                        <span></span>
                                                        <p>
                                                            {{ price }} €
                                                        </p>
                                                    </label>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-3 col-lg-4 col-md-6 col-12">
                    <div class="pill-search" :class="{ 'is-disabled': isFilterCommercial }">
                        <div class="input-group input-group-tags">
                            <ul class="results-tag-list" id="roomstagList">
                                <li v-for="roomCount in filters.selectedRoomsCount" :key="roomCount.id">
                                    <span class="results-tag">
                                    <span> {{ roomCount.name }} </span>
                                    <i
                                        class="fad fa-times-circle"
                                        @click="deleteRoomCount(roomCount)"
                                    ></i>
                                    </span>
                                </li>
                                <li @click="roomsSearchTrigger()">
                                    Nr. camere
                                </li>
                            </ul>
                        </div>
                        <div class="search-results-box" id="roomSearchResultBox">
                            <ul class="search-results-list">
                                <li
                                    class="main-result-item"
                                    v-for="roomCount in roomsCount"
                                    :key="`room-${roomCount.id}`"
                                >
                                    <div class="search-result-line">
                                        <div class="result-checkbox">
                                            <input
                                                type="checkbox"
                                                class="custom-checkbox"
                                                :id="`room-${roomCount.id}`"
                                                :value="roomCount"
                                                v-model="filters.selectedRoomsCount"
                                                @change="changeRoomsCount"
                                            />
                                            <label
                                                class="custom-checkbox-label"
                                                :for="`room-${roomCount.id}`"
                                            >
                                                <span></span>
                                                <p>
                                                    {{ roomCount.name }}
                                                </p>
                                            </label>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="search-result-footer">
                                <button
                                    type="button"
                                    name="button"
                                    class="general-btn negative-btn"
                                    @click="closeRoomsResults()"
                                >
                                    <i class="fad fa-times-circle"></i>
                                    <span> Inchide </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-3 col-lg-2 col-md-6 col-12">
                    <div class="singular-check">
                        <input
                            type="checkbox"
                            value="1"
                            id="developerInstallements"
                            class="custom-checkbox"
                            v-model="filters.ratesToDeveloper"
                            @change="changeRatesToDeveloper()"
                        />
                        <label for="developerInstallements" class="custom-checkbox-label">
                            <span></span>
                            Rate la dezvoltator
                        </label>
                    </div>
                </div>
                <div class="mt-3 col-lg-6 col-md-6 col-12">
                    <div class="reset-btn-wrapper">
                        <div
                            class="general-btn icon-btn reset-btn"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Reseteaza Filtre"
                            @click="resetFilters()"
                        >
                            <span>Reseteaza Filtre</span>
                            <i class="fad fa-undo-alt"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="search-row">
           <div class=" search-row__mobile-container search-row__mobile-container--top-border">
                <div class="single-search-pill single-search-pill--filter-mobile" @click="show = !show">
                    <div class="pill-search">
                        <div class="single-search-pill__mobile-filter-text">
                            Filtre
                        </div>
                    </div>
                    <div class="single-search-pill__icon single-search-pill__icon--filters">
                         <i class="fas fa-sliders-h"></i>
                        <div class="single-search-pill__dot-filter" v-if="filtersCounter > 0">

                        </div>
                    </div>
                </div>
                <div class="single-search-pill single-search-pill--filter-mobile" style="min-width:120px!important;" >
                     <div class="single-search-pill__icon single-search-pill__icon--sort">
                            <i class="fad fa-sort-size-up-alt"></i> 
                            <div class="single-search-pill__dot-filter" v-if="sortBy != ''">

                            </div>
                        </div>
                        <select v-model="sortBy" @change="changeSort" style="border:none;width:80%;" id="sortSelect">
                            <input>
                                <!--<option> Top listing </option>-->
                                <option value="" selected="selected">Sortati</option>
                                <option value="lower_price">Pret crescator</option>
                                <option value="highest_price">Pret descrescator</option>
                                <option value="lower_price_mp">Pret/(m²) crescator</option>
                                <option value="highest_price_mp">Pret/(m²) descrescator</option>
                                <option value="lower_surface">Suprafata crescatoare (m²)</option>
                                <option value="highest_surface">Suprafata descrescatoare (m²)</option>
                            >  
                        </select>
                </div>
                

                <div class="single-search-pill single-search-pill--filter-mobile">  

                    <div
                        class="transformer-btn"
                        @click="changeLayout(LAYOUT_MODE_CARD)"
                        :class="{
                            'd-none': !isLayoutModeMap,
                            'transform_btn_active': isLayoutModeCard
                        }"
                    >
                        <span>Lista</span>
                        <i class="fad fad fa-th-list"></i>
                    </div>
                    <div
                        class="transformer-btn"
                        @click="changeLayout(LAYOUT_MODE_MAP)"
                        :class="{
                            'd-none': !isLayoutModeCard,
                            'transform_btn_active': isLayoutModeMap
                        }"
                    >
                        <span>Harta</span>
                        <i class="fad fa-map"></i>
                    </div>
                </div>                
            </div>

            <div class="search-row__mobile-container search-row__mobile-container--display-filter search-row__mobile-container--bottom-border">
                <ul class="display-filters">
                    <!-- AFISARE ORAS -->
                    <li v-for="city in filters.selectedCities" :key="city.id">
                        <span class="results-tag">
                        <span> {{ city.name }} </span>
                            <i
                                class="fad fa-times-circle"
                                @click="deleteCity(city)"
                            ></i>
                        </span>
                    </li>

                    <!-- AFISARE ZONA -->
                    <li v-for="zone in filters.selectedZones" :key="zone.id">
                        <span class="results-tag">
                        <span> {{ zone.name }} </span>
                            <i
                                class="fad fa-times-circle"
                                @click="deleteZone(zone)"
                            ></i>
                        </span>
                    </li>

                    <!-- AFISARE NR CAMERE -->
                    <li v-for="roomCount in filters.selectedRoomsCount" :key="roomCount.id">
                        <span class="results-tag">
                        <span> {{ roomCount.name }} </span>
                            <i
                                class="fad fa-times-circle"
                                @click="deleteRoomCount(roomCount)"
                            ></i>
                        </span>
                    </li>
                    
                    <!-- AFISARE TIP PROPRIETATE -->

                    <li v-if="filters.type=='apartment'">
                        <span class="results-tag">
                        <span> Apartamente </span>
                            <i
                                class="fad fa-times-circle"
                                @click="deleteMobileFilterType()"
                            ></i>
                        </span>
                    </li>
                    <li v-else-if="filters.type=='house'">
                        <span class="results-tag">
                        <span> Case / Vile</span>
                         <i
                                class="fad fa-times-circle"
                                @click="deleteMobileFilterType()"
                            ></i>
                        </span>
                    </li>
                    <li v-else-if="filters.type=='commercial'">
                        <span class="results-tag">
                        <span> Spatii </span>
                         <i
                                class="fad fa-times-circle"
                                @click="deleteMobileFilterType()"
                            ></i>
                        </span>
                    </li>

                    <!-- Afisare Pret -->
                    <li v-if ="filters.minPrice != null || filters.maxPrice != null ">
                        <span class="results-tag">
                          <span v-if ="filters.minPrice == null "> 10000 &euro;- {{filters.maxPrice}}  &euro; </span>
                          <span v-else-if="filters.maxPrice==null"> {{filters.minPrice}} &euro; - 200000  &euro;</span>
                          <span v-else> {{filters.minPrice}} &euro; - {{filters.maxPrice}}  &euro;</span>
                         <i
                                class="fad fa-times-circle"
                                @click="deleteMobileFilterPrice()"
                            ></i>
                        </span>

                    </li>
                    

                    <!-- Afisare Suprafata -->
                    <li v-if ="filters.minSurface != null || filters.maxSurface != null ">
                        <span class="results-tag">
                          <span v-if ="filters.minSurface == null "> 0 &#13217; - {{filters.maxSurface}} &#13217; </span>
                          <span v-else-if="filters.maxSurface == null"> {{filters.minSurface}} &#13217; - 200 &#13217;</span>
                          <span v-else> {{filters.minSurface}} &#13217; - {{filters.maxSurface}} &#13217;</span>
                         <i
                                class="fad fa-times-circle"
                                @click="deleteMobileFilterSurface()"
                            ></i>
                        </span>

                    </li>
                    <!-- Afisare Rate la dezvoltator -->
                    <li v-if="filters.ratesToDeveloper != null ">
                        <span class="result-tag"></span>
                            <span> Rate la dezvoltator</span>
                             <i
                                class="fad fa-times-circle"
                                @click="deleteMobileFilterRatesToDeveloper()"
                            ></i>

                    </li>
                    <!-- Afisare sort -->
                    <li v-if="sortBy == 'lower_price'">
                        <span class="result-tag"></span>
                            <span> Pret Crescator</span>
                            <i
                                class="fad fa-times-circle"
                                @click="resetSort()"
                               
                            ></i>
                    </li>
                     <li v-else-if="sortBy == 'highest_price'">
                        <span class="result-tag"></span>
                            <span> Pret descrescator</span>
                            <i
                                class="fad fa-times-circle"
                                @click="resetSort()"

                               
                            ></i>
                    </li>
                     <li v-if="sortBy == 'lower_price_mp'">
                        <span class="result-tag"></span>
                            <span> Pret/(m²) Crescator</span>
                            <i
                                class="fad fa-times-circle"
                                @click="resetSort()"                               

                               
                            ></i>
                    </li>
                     <li v-else-if="sortBy == 'highest_price_mp'">
                        <span class="result-tag"></span>
                            <span> Pret/(m²) descrescator</span>
                            <i
                                class="fad fa-times-circle"
                                @click="resetSort()"
                            ></i>
                    </li>
                    <li v-else-if="sortBy == 'lower_surface'">
                        <span class="result-tag"></span>
                            <span> Suprafata crescatoare</span>
                            <i
                                class="fad fa-times-circle"
                                @click="resetSort()"
                            ></i>
                    </li>
                    <li v-else-if="sortBy == 'highest_surface'">
                        <span class="result-tag"></span>
                            <span> Suprafata descrescatoare</span>
                            <i
                                class="fad fa-times-circle"
                                @click="resetSort()"
                            ></i>
                    </li>
                 
                </ul>
              
            </div>
            
            <h1 class="section-title">
                {{ pageTitle }}
            </h1>
        </div>
        <div class="projects-list-row">
            <div class="row">
                <div class="col-xl-12">
                    <div class="pp-list-heading">
                        <div>
                            <a
                                class="general-btn attention-btn btn-news pulse-btn notification-btn" id="generalNewsfeed"
                            >
                                <i class="fas fa-play"></i>
                                <span>Vezi toate noutatile</span>
                                <span class="notification-count"
                                      v-if="latestDeveloperNewsCount > 0"> {{ latestDeveloperNewsCount }} </span>
                            </a>

                            <div class="filters-mobile__field-search">
                                <div
                                    class="listingBtn"
                                    :class="{ active: isLayoutModeCard }"
                                    @click="changeLayout(LAYOUT_MODE_CARD)"
                                >
                                    {{ projectsListingLabel }}
                                </div>
                                /
                                <div
                                    class="listingBtn"
                                    :class="{ active: isLayoutModeModels }"
                                    @click="changeLayout(LAYOUT_MODE_MODELS)"
                                >
                                    {{ modelsListingLabel }}
                                </div>
                            </div>
                        </div>
                        <!-- <div class="sorting-group">
                            <div class="input-group">
                                <select v-model="sortBy" @change="changeSort">
                                    <option selected disabled value="">
                                        Sorteaza dupa
                                    </option>
                                    <option> Top listing </option>
                                    <option value="lower_price">Pret crescator</option>
                                    <option value="highest_price">Pret descrescator</option>
                                    <option value="lower_price_mp">Pret/(m²) crescator</option>
                                    <option value="highest_price_mp">
                                        Pret/(m²) descrescator
                                    </option>
                                    <option value="lower_surface">
                                        Suprafata crescatoare (m²)
                                    </option>
                                    <option value="highest_surface">
                                        Suprafata descrescatoare (m²)
                                    </option>
                                </select>
                                <div class="input-icon">
                                    <i class="fad fa-sort-size-up-alt"></i>
                                </div>
                                <label class="custom-label" for="roomsCount"> Sorteaza dupa </label>
                            </div>
                        </div> -->

                        <div class="sorting-group">
                            <div class="input-group">
                                <select v-model="sortBy" @change="changeSort">
                                    <option selected disabled value="">
                                        Sorteaza dupa
                                    </option>
                                    <!--<option> Top listing </option>-->
                                    <option value="lower_price">Pret crescator</option>
                                    <option value="highest_price">Pret descrescator</option>
                                    <option value="lower_price_mp">Pret/(m²) crescator</option>
                                    <option value="highest_price_mp">
                                        Pret/(m²) descrescator
                                    </option>
                                    <option value="lower_surface">
                                        Suprafata crescatoare (m²)
                                    </option>
                                    <option value="highest_surface">
                                        Suprafata descrescatoare (m²)
                                    </option>
                                </select>
                                <div class="input-icon">
                                    <i class="fad fa-sort-size-up-alt"></i>
                                </div>
                                <!-- <label class="custom-label" for="roomsCount"> Sorteaza dupa </label> -->
                            </div>
                            <div class="layout-transformer-wrapper">
                                <div
                                    class="transformer-btn"
                                    @click="changeLayout(LAYOUT_MODE_CARD)"
                                    :class="{ transform_btn_active: isLayoutModeCard }"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Afisare tip card"
                                >
                                    <i class="fad fa-th-large"></i>
                                </div>
                                <div
                                    class="transformer-btn"
                                    @click="changeLayout(LAYOUT_MODE_LIST)"
                                    :class="{ transform_btn_active: isLayoutModeList }"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Afisare tip lista"
                                >
                                    <i class="fad fa-th-list"></i>
                                </div>
                                <div
                                    class="transformer-btn"
                                    @click="changeLayout(LAYOUT_MODE_MAP)"
                                    :class="{ transform_btn_active: isLayoutModeMap }"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Afisare harta proiecte"
                                >
                                    <i class="fad fa-map"></i>
                                </div>
                                <!-- HIDE MODEL VIEW-->
                                <div
                                    class="transformer-btn"
                                    @click="changeLayout(LAYOUT_MODE_MODELS)"
                                    :class="{ transform_btn_active: isLayoutModeModels }"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Afisare modele"
                                    v-if="false"
                                >
                                    <i class="fad fa-layer-group"></i>
                                </div>
                            </div>
                        </div>
                    
                    </div>
                </div>
            </div>
            <div class="row">
                <div
                    class="col-xl-12"
                    v-if="projects.length === 0">
                    <div class="pp-list-heading" style="align-items: center; justify-content: center; margin-top: 30px;">
                        <strong>
                            {{noResultsText}} - <a :href="noResultsLinkUrl"><span>{{noResultsLinkText}}</span></a>
                        </strong>
                    </div>
                </div>
                <div
                    v-for="(project, index) in projects"
                    :key="`layout1-${index}`"
                    class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mgb-3 cardtype-col element-cardtype-box"
                    :class="{ hidden_col: !isLayoutModeCard }"
                >
                    <div class="element-box">
                        <div class="element-header">
                            <div
                                class="element-logo"
                                :key="`element-logo-${index}-${project.id}`"
                                :style="{ backgroundImage: 'url(' + project.logo_url + ')' }"
                            ></div>
                            <div class="element-info">
                                <a
                                    :href="`${project.url}`"
                                    @click="storeProjectUrlParamsInLocalStorage()"
                                    class="general-link element-name"
                                >
                                    {{ project.name }}
                                </a>
                                <div class="element-location">
                                    <i class="fad fa-map-marker-alt"></i>
                                    <p>
                                        {{ getProjectLocation(project) }}
                                    </p>
                                </div>
                            </div>
                            <div
                                v-if="checkFavoriteProject(project)"
                                class="floating-favourite-element floating-active-favrourite"
                            >
                                <i
                                    class="fas fa-heart"
                                    @click="deleteFavoriteProject(project.id)"
                                ></i>
                            </div>
                            <div v-else class="floating-favourite-element">
                                <i
                                    class="fas fa-heart"
                                    @click="openAddFavoriteProjectModal(project.id)"
                                ></i>
                            </div>
                            <div class="element-dropdown">
                                <div
                                    class="element-floating-menu"
                                    @click="setActiveDropdown(index)"
                                >
                                    <i class="fad fa-ellipsis-v-alt"></i>
                                </div>
                                <ul
                                    class="actions-dropdown"
                                    :class="{ actions_dropdown_active: activeIndex === index }"
                                >
                                    <li>
                                        <i class="fad fa-phone-rotary"></i>
                                        <a
                                            href="javascript:void(0)"
                                            class="general-link"
                                            @click="openPublicContactModalProject(project)"
                                        >
                                            Call
                                        </a>
                                    </li>
                                    <li>
                                        <i class="fad fa-copy"></i>
                                        <a
                                            href="javascript:void(0)"
                                            @click="copyLink(project, 'project')"
                                            class="general-link"
                                        >
                                            Copy link
                                        </a>
                                    </li>
                                    <li>
                                        <i class="fab fa-whatsapp"></i>
                                        <a
                                            :href="`https://api.whatsapp.com/send?text=${project.absoluteUrl}`"
                                            class="general-link"
                                            target="_blank"
                                        >
                                            Share Whatsapp
                                        </a>
                                    </li>
                                    <li>
                                        <i class="fab fa-facebook-square"></i>
                                        <a
                                            :href="`https://www.facebook.com/sharer/sharer.php?u=${project.absoluteUrl}`"
                                            class="general-link"
                                            target="_blank"
                                        >
                                            Share Facebook
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="element-body">
                            <p class="element-description">
                                {{ project.short_desc }}
                            </p>
                            <a
                                :href="`${project.url}`"
                                @click="storeProjectUrlParamsInLocalStorage()"
                                class="element-image"
                                :style="{ backgroundImage: 'url(' + project.profile_image_url + ')' }"
                            >
                                <div class="element-badge-wrapper"
                                     v-if="project.today_sold_items_count + project.yesterday_sold_items_count + project.recent_sold_items_count + project.recent_posts_count > 0"
                                >
                                    <span class="element-news-badge" v-if="project.today_sold_items_count > 1">
                                        {{ project.today_sold_items_count }} oferte vandute azi
                                    </span>
                                    <span class="element-news-badge" v-else-if="project.today_sold_items_count == 1">
                                        {{ project.today_sold_items_count }} oferta vanduta azi
                                    </span>
                                    <span class="element-news-badge" v-else-if="project.yesterday_sold_items_count > 1">
                                        {{ project.yesterday_sold_items_count }} oferte vandute ieri
                                    </span>
                                    <span class="element-news-badge" v-else-if="project.yesterday_sold_items_count == 1">
                                        {{ project.yesterday_sold_items_count }} oferta vanduta ieri
                                    </span>
                                    <span class="element-news-badge" v-else-if="project.recent_sold_items_count > 1">
                                        {{ project.recent_sold_items_count }} oferte vandute recent
                                    </span>
                                    <span class="element-news-badge" v-else-if="project.recent_sold_items_count == 1">
                                        {{ project.recent_sold_items_count }} oferta vanduta recent
                                    </span>
                                    <span class="element-news-badge" v-else-if="project.recent_posts_count > 1 && project.last_developer_news_days_ago == 0">
                                        {{ project.recent_posts_count }} postari noi
                                    </span>
                                    <span class="element-news-badge" v-else-if="project.recent_posts_count == 1 && project.last_developer_news_days_ago == 0">
                                        {{ project.recent_posts_count }} postare noua
                                    </span>
                                    <span class="element-news-badge" v-else-if="project.recent_posts_count > 1 && project.last_developer_news_days_ago > 0">
                                        {{ project.recent_posts_count }} postari acum {{ project.last_developer_news_days_ago }} {{ project.last_developer_news_days_ago > 1 ? 'zile' : 'zi' }}
                                    </span>
                                    <span class="element-news-badge" v-else-if="project.recent_posts_count == 1 && project.last_developer_news_days_ago > 0">
                                        {{ project.recent_posts_count }} postare acum {{ project.last_developer_news_days_ago }} {{ project.last_developer_news_days_ago > 1 ? 'zile' : 'zi' }}
                                    </span>
                                </div>
                                <div
                                    class="tags-container"
                                    v-if="checkNewFlag(project) || project.displayPromotionLevel"
                                >
                                    <div
                                        class="custom-tag project-new-status"
                                        v-if="checkNewFlag(project)"
                                    >
                                        Nou
                                    </div>
                                    <div
                                        :class="`custom-tag ${project.promotionLevelCssClass}`"
                                        v-if="project.displayPromotionLevel"
                                    >
                                        {{ project.promotionLevelName }}
                                    </div>
                                </div>
                                <div class="pb">
                                    <p class="tag tag-photo">
                                        <i class="fad fa-image"></i>
                                        <span> {{ project.media_count }} </span>
                                    </p>
                                    <p class="tag tag-video">
                                        <i class="fad fa-play-circle"></i>
                                        <span> {{ project.videos.length }} </span>
                                    </p>
                                </div>
                            </a>
                            <div class="element-particularities">
                                <div class="ep ep1" v-if="project.apartments_models_count > 0">
                                    <span
                                        v-if="!project.hasAccessToProjectItems"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Pentru informatii despre numarul de apartamente disponibil sunati la numarul de contact din proiect"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Apartamente</span>
                                    </span>
                                    <span
                                        v-else-if="project.apartments_count === 0"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Dezvoltatorul nu a afisat disponibilitatile"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Apartamente</span>
                                    </span>
                                    <span v-else>
                                        <a
                                            :href="`${project.url}?tip=apartament`"
                                            class="general-link"
                                        >
                                            {{ project.apartments_count }} Apartamente
                                        </a>
                                    </span>
                                </div>
                                <div class="ep ep2" v-if="project.houses_models_count > 0">
                                    <span
                                        v-if="!project.hasAccessToProjectItems"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Pentru informatii despre numarul de case disponibil sunati la numarul de contact din proiect"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Case</span>
                                    </span>
                                    <span
                                        v-else-if="project.houses_count === 0"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Dezvoltatorul nu a afisat disponibilitatile"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Case</span>
                                    </span>
                                    <span v-else>
                                        <a
                                            :href="`${project.url}?tip=casa`"
                                            class="general-link"
                                        >
                                            {{ project.houses_count }} Case
                                        </a>
                                    </span>
                                </div>
                                <div class="ep ep3" v-if="project.commercials_models_count > 0">
                                    <span
                                        v-if="!project.hasAccessToProjectItems"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Pentru informatii despre numarul de spaţii disponibil sunati la numarul de contact din proiect"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Spaţii</span>
                                    </span>
                                    <span
                                        v-else-if="project.commercials_count === 0"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Dezvoltatorul nu a afisat disponibilitatile"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Spaţii</span>
                                    </span>
                                    <span v-else>
                                        <a
                                            :href="`${project.url}?tip=spatiu`"
                                            class="general-link"
                                        >
                                            {{ project.commercials_count }} Spaţii
                                        </a>
                                    </span>
                                </div>
                            </div>
                            <div class="element-footer">
                                <div class="element-price">
                                    <span v-if="project.min_price != project.max_price">
                                        {{ formatPrice(project.min_price, false) }} -
                                        {{ formatPrice(project.max_price) }}
                                    </span>
                                    <span v-else>
                                        {{ formatPrice(project.min_price) }}
                                    </span>
                                </div>
                                <div class="element-size">
                                    <span v-if="project.min_surface != project.max_surface">
                                        {{ project.min_surface }} - {{ project.max_surface }} m²
                                    </span>
                                    <span v-else>{{ project.min_surface }} m²</span>
                                </div>
                            </div>
                            <div class="element-cta-wrapper">
                                <a 
                                    :href="`${project.url}`"
                                    @click="storeProjectUrlParamsInLocalStorage()"
                                    class="general-btn positive-btn"
                                ><span> Vezi oferte </span></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-for="(project, index) in projects"
                    :key="`layout2-${index}`"
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mgb-3 cardtype-col element-listtype-col"
                    :class="{ hidden_col: !isLayoutModeList }"
                >
                    <div class="element-box element-listtype-box">
                        <a
                            class="element-image u-cursor-pointer"
                            :style="{ backgroundImage: 'url(' + project.profile_image_url + ')' }"
                            :href="`${project.url}`"
                            @click="storeProjectUrlParamsInLocalStorage()"
                        >
                            <div
                                class="tags-container"
                                v-if="checkNewFlag(project) || project.displayPromotionLevel"
                            >
                                <div
                                    class="custom-tag project-new-status"
                                    v-if="checkNewFlag(project)"
                                >
                                    Nou
                                </div>
                                <div
                                    :class="`custom-tag ${project.promotionLevelCssClass}`"
                                    v-if="project.displayPromotionLevel"
                                >
                                    {{ project.promotionLevelName }}
                                </div>
                            </div>
                            <div class="pb">
                                <p class="tag tag-photo">
                                    <i class="fad fa-image"></i>
                                    <span> {{ project.media_count }} </span>
                                </p>
                                <p class="tag tag-video">
                                    <i class="fad fa-play-circle"></i>
                                    <span> {{ project.videos.length }} </span>
                                </p>
                            </div>
                        </a>
                        <div class="element-body">
                            <div class="element-header">
                                <div
                                    class="element-logo"
                                    :style="{ backgroundImage: 'url(' + project.logo_url + ')' }"
                                ></div>
                                <div class="element-info">
                                    <a
                                        :href="`${project.url}`"
                                        @click="storeProjectUrlParamsInLocalStorage()"
                                        class="general-link element-name"
                                    >
                                        {{ project.name }}
                                    </a>
                                    <div class="element-location">
                                        <i class="fad fa-map-marker-alt"></i>
                                        <p>
                                            {{ getProjectLocation(project) }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <p class="element-description">
                                {{ project.short_desc }}
                            </p>
                            <div class="element-particularities">
                                <div class="ep ep1">
                                    <span
                                        v-if="!project.hasAccessToProjectItems"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Pentru informatii despre numarul de apartamente disponibil sunati la numarul de contact din proiect"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Apartamente</span>
                                    </span>
                                    <span
                                        v-else-if="project.apartments_count === 0"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Dezvoltatorul nu a afisat disponibilitatile"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Apartamente</span>
                                    </span>
                                    <span v-else>
                                        <a
                                            :href="`${project.url}?tip=apartament`"
                                            class="general-link"
                                        >
                                            {{ project.apartments_count }} Apartamente
                                        </a>
                                    </span>
                                </div>
                                <div class="ep ep2">
                                    <span
                                        v-if="!project.hasAccessToProjectItems"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Pentru informatii despre numarul de case disponibil sunati la numarul de contact din proiect"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Case</span>
                                    </span>
                                    <span
                                        v-else-if="project.houses_count === 0"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Dezvoltatorul nu a afisat disponibilitatile"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Case</span>
                                    </span>
                                    <span v-else>
                                        <a
                                            :href="`${project.url}?tip=casa`"
                                            class="general-link"
                                        >
                                            {{ project.houses_count }} Case
                                        </a>
                                    </span>
                                </div>
                                <div class="ep ep3">
                                    <span
                                        v-if="!project.hasAccessToProjectItems"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Pentru informatii despre numarul de spaţii disponibil sunati la numarul de contact din proiect"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Spaţii</span>
                                    </span>
                                    <span
                                        v-else-if="project.commercials_count === 0"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Dezvoltatorul nu a afisat disponibilitatile"
                                    >
                                        <i class="fad fa-info-circle"></i>
                                        <span class="unknown">Spaţii</span>
                                    </span>
                                    <span v-else>
                                        <a
                                            :href="`${project.url}?tip=spatiu`"
                                            class="general-link"
                                        >
                                            {{ project.commercials_count }} Spaţii
                                        </a>
                                    </span>
                                </div>
                            </div>
                            <div class="element-footer">
                                <div class="element-price">
                                    <span v-if="project.min_price != project.max_price">
                                        {{ formatPrice(project.min_price, false) }} -
                                        {{ formatPrice(project.max_price) }}
                                    </span>
                                    <span v-else>
                                        {{ formatPrice(project.min_price) }}
                                    </span>
                                </div>
                                <div class="element-size">
                                    <span v-if="project.min_surface != project.max_surface">
                                        {{ project.min_surface }} - {{ project.max_surface }} m²
                                    </span>
                                    <span v-else>{{ project.min_surface }} m²</span>
                                </div>
                            </div>
                            <div
                                v-if="checkFavoriteProject(project)"
                                class="floating-favourite-element floating-active-favrourite"
                            >
                                <i
                                    class="fas fa-heart"
                                    @click="deleteFavoriteProject(project.id)"
                                ></i>
                            </div>
                            <div
                                v-else
                                class="floating-favourite-element"
                                data-toggle="modal"
                                data-target="#favourite_item_modal"
                            >
                                <i
                                    class="fas fa-heart"
                                    @click="openAddFavoriteProjectModal(project.id)"
                                ></i>
                            </div>
                            <div class="element-dropdown">
                                <div
                                    class="element-floating-menu"
                                    @click="setActiveDropdown(index)"
                                >
                                    <i class="fad fa-ellipsis-v-alt"></i>
                                </div>
                                <ul
                                    class="actions-dropdown"
                                    :class="{ actions_dropdown_active: activeIndex === index }"
                                >
                                    <li>
                                        <a
                                            href="javascript:void(0)"
                                            @click="openPublicContactModalProject(project)"
                                            class="general-link"
                                        >
                                            Call
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="javascript:void(0)"
                                            @click="copyLink(project, 'project')"
                                            class="general-link"
                                        >
                                            Copy link
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            :href="`https://api.whatsapp.com/send?text=${project.absoluteUrl}`"
                                            class="general-link"
                                        >
                                            Share Whatsapp
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            :href="`https://www.facebook.com/sharer/sharer.php?u=${project.absoluteUrl}`"
                                            class="general-link"
                                            target="_blank"
                                        >
                                            Share Facebook
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mgb-3"
                    :class="{ hidden_col: !isLayoutModeMap }"
                >
                    <list-projects-map
                        ref="prOnMaps"
                        :projects="this.mapProjects"
                        :url-params="urlParams"
                    ></list-projects-map>
                </div>

                <div
                    v-for="(model, index) in projectModels"
                    :key="`layout3-${index}`"
                    class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
                    :class="{ hidden_col: !isLayoutModeModels }"
                >
                    <div class="pp-model-item">
                        <div class="sold-tag" v-if="model.total_items > 0 && model.total_items === model.items_sold">
                            Vandut
                        </div>
                        <div class="element-header">
                            <div class="element-info">
                                <a
                                    :href="`${model.project.url}`"
                                    @click="storeProjectUrlParamsInLocalStorage()"
                                    class="general-link element-name"
                                >
                                    {{ model.project.name }}
                                </a>
                                <div class="element-location">
                                    <i class="fad fa-map-marker-alt"></i>
                                    <p>
                                        {{ getProjectLocation(model.project) }}
                                    </p>
                                </div>
                            </div>
                            <div
                                v-if="checkFavoriteModel(model)"
                                class="floating-favourite-element floating-active-favrourite"
                            >
                                <i
                                    class="fas fa-heart"
                                    @click="deleteFavoriteModel(model.id)"
                                ></i>
                            </div>
                            <div v-else class="floating-favourite-element">
                                <i
                                    class="fas fa-heart"
                                    @click="openAddFavoriteModelModal(model.id)"
                                ></i>
                            </div>
                            <div class="element-dropdown">
                                <div class="element-floating-menu" @click="setActiveDropdown(index)">
                                    <i class="fad fa-ellipsis-v-alt"></i>
                                </div>
                                <ul
                                    class="actions-dropdown"
                                    :class="{'actions_dropdown_active': activeIndex === index}"
                                    ref="dropdown"
                                >
                                    <li>
                                        <i class="fad fa-phone-rotary"></i>
                                        <a href="javascript:void(0)" class="general-link" @click="openPublicContactModalProject(model.project,model)"> Call </a>
                                    </li>
                                    <li>
                                        <i class="fad fa-copy"></i>
                                        <a href="javascript:void(0)" class="general-link" @click="copyLink(model,'model')"> Copy link </a>
                                    </li>
                                    <li>
                                        <i class="fab fa-whatsapp"></i>
                                        <a :href="`https://api.whatsapp.com/send?text=${getFullModelUrl(model)}`" class="general-link" target="_blank"> Share Whatsapp </a>
                                    </li>
                                    <li>
                                        <i class="fab fa-facebook-square"></i>
                                        <a :href="`https://www.facebook.com/sharer/sharer.php?u=${getFullModelUrl(model)}`" class="general-link" target="_blank"> Share Facebook </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="pp-model-item-content pp-length-flex">
                            <div class="pp-model-picture pp-length-picture u-cursor-pointer" @click="openModelDetailModal(model.project_id, model.id, 'apartments')" :style="{ backgroundImage: 'url(' + model.first_listing_image_url + ')' }">
                            </div>
                            <div class="pp-model-info pp-length-info">
                                <div class="pp-model-info-strip">
                                    <h2 class="pp-model-item-heading">
                                        <a href="javascript:void(0)"
                                           @click="openModelDetailModal(model.project_id, model.id, 'apartments')"> {{ model.rooms_count ? model.rooms_count.name : '' }} tip {{ model.model_type }} </a>
                                    </h2>
                                </div>
                                <div class="pp-model-info-strip">
                                    <h2> Pret de la:</h2>
                                    <p v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                        --
                                    </p>
                                    <p class="xs-flex-full-width" v-else>
                                        {{ formatPrice(model.min_price) }} <span class="vat">{{model.price_with_vat ? 'TVA inclus' : '+TVA'}}</span>
                                    </p>
                                </div>
                                <div class="pp-model-info-strip" v-if="model.min_credit_price">
                                    <h2> Pret cu credit de la:</h2>
                                    <p v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                        --
                                    </p>
                                    <p class="xs-flex-full-width" v-else>
                                        {{ formatPrice(model.min_credit_price) }} <span class="vat">{{model.credit_price_with_vat ? 'TVA inclus' : '+TVA'}}</span>
                                    </p>
                                </div>
                                <div class="pp-model-info-strip">
                                    <ul>
                                        <li class="xs-flex-full-width">
                                            <span> Supr. totala: </span>
                                            <span> {{ model.min_surface }} m² </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="pp-model-info-strip">
                                    <p class="pp-avb-item" @click="openModelDetailModal(model.project_id, model.id, 'apartments')">
                                        <span v-if="model.project && model.project.hasAccessToProjectItems">
                                            Vezi disponibilitate ({{ model.items_count }})
                                        </span>
                                        <span v-else>
                                            Vezi detalii
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section-loading-screen page-bg-blend" v-show="showLoadingFilters">
                    <div class="section-loading-bubbles top-loader">
                        <span class="d1"></span>
                        <span class="d2"></span>
                        <span class="d3"></span>
                        <span class="d4"></span>
                    </div>
                </div>
            </div>
            <div
                class="row"
                v-if="!isLayoutModeMap && !isLayoutModeModels"
            >
                <div class="col-xl-12 col-lg-12 col-12">
                    <div v-html="paginationLinks" @click="handlePaginationClick"></div>
                </div>
            </div>
            <div
                class="row"
                v-if="isLayoutModeModels"
            >
                <div class="col-xl-12 col-lg-12 col-12">
                    <div v-html="modelsPaginationLinks" @click="handleModelsPaginationClick"></div>
                </div>
            </div>
        </div>
        <favourite-item-modal ref="modalFav"></favourite-item-modal>
        <public-contact-modal-project></public-contact-modal-project>
    </div>
</template>

<script>
import FavouriteItemModal from "./partials/FavouriteItemModal";
import PublicContactModalProject from "./partials/PublicContactModalProject";
import veeno from 'veeno';
import 'nouislider/distribute/nouislider.min.css';

const LayoutMode = {
    CARD: 0,
    LIST: 1,
    MAP: 2,
    MODELS: 3
}

export default {
    name: "ProjectsList",
    components: { FavouriteItemModal, PublicContactModalProject, veeno},
    props: [
        'county', 'roomsCount', 'defFavorites', 'largestMinPrice',
        'preSelectedCitySlugList', 'preSelectedZoneSlugList', 'preSelectedType', 'preSelectedRtd'
    ],
    data() {
        return {
            LAYOUT_MODE_CARD: LayoutMode.CARD,
            LAYOUT_MODE_LIST: LayoutMode.LIST,
            LAYOUT_MODE_MAP: LayoutMode.MAP,
            LAYOUT_MODE_MODELS: LayoutMode.MODELS,

            activeIndex: undefined,
            citySearch: "",
            selectedCounty: this.county,
            zoneSearch: "",
            zones: [],
            projects: [],
            mapProjects: [],
            projectModels: [],
            totalFilteredProjects: 0,
            totalFilteredModels: 0,
            totalAvailableItems: 0,
            totalProjects: 0,
            layoutChange: LayoutMode.CARD,
            favorites: [],
            showLoadingFilters: false,
            urlParams: {},
            projectNameSearch: "",
            filters: {
                type: null,
                selectedCities: [],
                selectedRoomsCount: [],
                selectedZones: [],
                selectedSubzones: [],
                surfaceValues: [40, 50, 60, 70, 80, 90, 100, 150, 200, 748],
                minSurface: null,
                maxSurface: null,
                priceValues: this.largestMinPrice > 200000
                    ? [40000, 50000, 60000, 70000, 80000, 90000, 100000, 150000, 200000, Math.min(1000000, this.largestMinPrice)]
                    : [40000, 50000, 60000, 70000, 80000, 90000, 100000, 150000, 200000],
                minPrice: null,
                maxPrice: null,
                ratesToDeveloper: null,
            },
            minSurfaceHasFocus: false,
            maxSurfaceHasFocus: false,
            minPriceHasFocus: false,
            maxPriceHasFocus: false,
            selectedRoomsCountInactive: [],
            sortBy: "",
            show: false,
            latestDeveloperNewsCount: 0,
            paginationLinks: '',
            modelsPaginationLinks: '',
        };
    },
    created: function () {},
    mounted() {
        this.favorites = this.defFavorites;
        if(!this.favorites) {
            this.favorites = window.getLocalFavorites();
        }
        let vm = this;
        this.applyUrlFilters();
        this.setCenterMap();
        this.fetchLatestDeveloperNewsCount();
        this.$eventBus.$on("SAVED_FAVORITES", function (payLoad) {
            let fav = payLoad.fav;
            vm.favorites = vm.favorites || [];
            vm.favorites = vm.favorites.concat(fav);
        });
    
    },

    computed: {
        isLayoutModeCard() {
            return this.layoutChange === this.LAYOUT_MODE_CARD;
        },
        isLayoutModeList() {
            return this.layoutChange === this.LAYOUT_MODE_LIST;
        },
        isLayoutModeMap() {
            return this.layoutChange === this.LAYOUT_MODE_MAP;
        },
        isLayoutModeModels() {
            return this.layoutChange === this.LAYOUT_MODE_MODELS;
        },
        filtersCounter() {
            return (this.filters.type != null) + this.filters.selectedCities.length + this.filters.selectedZones.length + this.filters.selectedRoomsCount.length + (this.filters.minSurface != null) + (this.filters.maxSurface != null) +  (this.filters.minPrice != null) + (this.filters.maxPrice != null) + (this.filters.ratesToDeveloper != null);
        },
        citiesList() {
            if (this.citySearch.length > 2) {
                return this.county.cities.filter((city) => {
                    return city.name
                        .toLowerCase()
                        .includes(this.citySearch.toLowerCase());
                });
            } else {
                return this.county.cities;
            }
        },
        zonesList() {
            if (this.zoneSearch.length > 2) {
                return this.zones.filter((zone) => {
                    return zone.projectCount > 0 &&
                        zone.name.toLowerCase().includes(this.zoneSearch.toLowerCase());
                });
            } else {
                return this.zones.filter((zone) => {
                    return zone.projectCount > 0;
                });
            }
        },
        isFilterCommercial() {
            return this.filters.type === 'commercial'
        },
        surfaceValuesMax() {
            return this.filters.surfaceValues[this.filters.surfaceValues.length - 1]
        },
        priceValuesMax() {
            return this.filters.priceValues[this.filters.priceValues.length - 1]
        },
        pageTitle() {
            let cityName = this.filters.selectedCities.length > 0
                ? this.filters.selectedCities.map((e) => e.name).join(", ")
                : this.county.name;
            let zoneName = this.filters.selectedZones.length > 0
                ? this.filters.selectedZones.map((e) => e.name).join(", ")
                : null;

            let title = 'Proiecte și ansambluri rezidențiale în ' + cityName;

            switch(true) {
                case Boolean(this.filters.type === 'apartment' && !zoneName && !this.filters.ratesToDeveloper):
                    title = 'Apartamente noi de vânzare în ' + cityName;
                    break;
                case Boolean(this.filters.type === 'house' && !zoneName && !this.filters.ratesToDeveloper):
                    title = 'Case și vile noi de vânzare în ' + cityName;
                    break;
                case Boolean(this.filters.type === 'commercial' && !zoneName && !this.filters.ratesToDeveloper):
                    title = 'Spații comerciale noi de vânzare în ' + cityName;
                    break;
                case Boolean(!this.filters.type && zoneName && !this.filters.ratesToDeveloper):
                    title = 'Proiecte și ansambluri rezidențiale în ' + zoneName + ', ' + cityName;
                    break;
                case Boolean(this.filters.type === 'apartment' && zoneName && !this.filters.ratesToDeveloper):
                    title = 'Apartamente noi de vânzare în ' + zoneName + ', ' + cityName;
                    break;
                case Boolean(this.filters.type === 'house' && zoneName && !this.filters.ratesToDeveloper):
                    title = 'Case și vile noi de vânzare în ' + zoneName + ', ' + cityName;
                    break;
                case Boolean(this.filters.type === 'commercial' && zoneName && !this.filters.ratesToDeveloper):
                    title = 'Spații comerciale noi de vânzare în ' + zoneName + ', ' + cityName;
                    break;
                case Boolean(!this.filters.type && !zoneName && this.filters.ratesToDeveloper):
                    title = 'Proiecte și ansambluri rezidențiale în ' + cityName + ' – Rate la Dezvoltator';
                    break;
                case Boolean(this.filters.type === 'apartment' && !zoneName && this.filters.ratesToDeveloper):
                    title = 'Apartamente noi de vânzare în ' + cityName + ' – Rate la Dezvoltator';
                    break;
                case Boolean(this.filters.type === 'house' && !zoneName && this.filters.ratesToDeveloper):
                    title = 'Case și vile noi de vânzare în ' + cityName + ' – Rate la Dezvoltator';
                    break;
                case Boolean(this.filters.type === 'commercial' && !zoneName && this.filters.ratesToDeveloper):
                    title = 'Spații comerciale noi de vânzare în ' + cityName + ' – Rate la Dezvoltator';
                    break;
                case Boolean(!this.filters.type && zoneName && this.filters.ratesToDeveloper):
                    title = 'Proiecte și ansambluri rezidențiale în ' + zoneName + ', ' + cityName + ' – Rate la Dezvoltator';
                    break;
                case Boolean(this.filters.type === 'apartment' && zoneName && this.filters.ratesToDeveloper):
                    title = 'Apartamente noi în ' + zoneName + ', ' + cityName + ' – Rate la Dezvoltator';
                    break;
                case Boolean(this.filters.type === 'house' && zoneName && this.filters.ratesToDeveloper):
                    title = 'Case sau vile noi în ' + zoneName + ', ' + cityName + ' – Rate la Dezvoltator';
                    break;
                case Boolean(this.filters.type === 'commercial' && zoneName && this.filters.ratesToDeveloper):
                    title = 'Spații comerciale noi în ' + zoneName + ', ' + cityName + ' – Rate la Dezvoltator';
                    break;
            }

            return title;
        },

        showFilters() {
            let showFilter = '';
            switch(this.filters.type) {
                case 'apartament':
                    'apartament';
                    break;
                case 'house':
                    'house';
                    break;
                case 'commercial':
                    'comercial';
                    break;
            }
            return showFilter;
        },

        minSurfaceHasFocusOrValue() {
            return this.minSurfaceHasFocus || (this.filters.minSurface !== null && this.filters.minSurface.toString() !== '');
        },
        maxSurfaceHasFocusOrValue() {
            return this.maxSurfaceHasFocus || (this.filters.maxSurface !== null && this.filters.maxSurface.toString() !== '');
        },
        minPriceHasFocusOrValue() {
            return this.minPriceHasFocus || (this.filters.minPrice !== null && this.filters.minPrice.toString() !== '');
        },
        maxPriceHasFocusOrValue() {
            return this.maxPriceHasFocus || (this.filters.maxPrice !== null && this.filters.maxPrice.toString() !== '');
        },

        projectsListingLabel() {
            return this.totalFilteredProjects + (this.totalFilteredProjects === 1 ? ' proiect' : ' proiecte');
        },
        modelsListingLabel() {
            let label;
            switch(this.filters.type) {
                case 'apartment':
                    label = 'tipuri de apartamente ' + (this.totalFilteredModels ? this.totalFilteredModels : '');
                    break;
                case 'house':
                    label = 'tipuri de case ' + (this.totalFilteredModels ? this.totalFilteredModels : '');
                    break;
                case 'commercial':
                    label = 'tipuri de spații comerciale ' + (this.totalFilteredModels ? this.totalFilteredModels : '');
                    break;
                default:
                    label = 'tipuri de oferte ' + (this.totalFilteredModels ? this.totalFilteredModels : '');
            }
            return label;
        },
        queryParams() {
            let params = Object.assign({}, this.urlParams);

            if (Object.prototype.hasOwnProperty.call(params, 'rooms_count')) {
                params.camere = params.rooms_count;
                delete params.rooms_count;
            }
            if (Object.prototype.hasOwnProperty.call(params, 'min_surface')) {
                params.suprafata_min = params.min_surface;
                delete params.min_surface;
            }
            if (Object.prototype.hasOwnProperty.call(params, 'max_surface')) {
                params.suprafata_max = params.max_surface;
                delete params.max_surface;
            }
            if (Object.prototype.hasOwnProperty.call(params, 'min_price')) {
                params.pret_min = params.min_price;
                delete params.min_price;
            }
            if (Object.prototype.hasOwnProperty.call(params, 'max_price')) {
                params.pret_max = params.max_price;
                delete params.max_price;
            }
            if (Object.prototype.hasOwnProperty.call(params, 'type')) {
                switch (params.type) {
                    case 'apartment':
                        params.tip = 'apartament';
                        break;
                    case 'house':
                        params.tip = 'casa';
                        break;
                    case 'commercial':
                        params.tip = 'spatiu';
                        break;
                    default:
                        params.tip = params.type;
                }
                delete params.type;
            }

            return params;
        },
        projectUrlParams: function() {
            let keysToClone = ['camere', 'tip', 'model', 'suprafata_min', 'suprafata_max', 'pret_min', 'pret_max'];
            return Object.fromEntries(
                Object.entries(this.queryParams).filter(([key]) => keysToClone.includes(key))
            );
        },
        noResultsText: function () {
            let cityName = this.filters.selectedCities[0] ? this.filters.selectedCities[0].name : 'oras';
            let zoneName = this.filters.selectedZones.length === 1 ? this.filters.selectedZones[0].name : null;

            let text = 'Momentan nu sunt proiecte disponibile';

            switch(true) {
                case Boolean(this.filters.type === 'apartment' && !zoneName && !this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt apartamente disponibile';
                    break;
                case Boolean(this.filters.type === 'house' && !zoneName && !this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt case sau vile disponibile';
                    break;
                case Boolean(this.filters.type === 'commercial' && !zoneName && !this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt spații comerciale disponibile';
                    break;
                case Boolean(!this.filters.type && !zoneName && this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt proiecte cu rate în ' + cityName;
                    break;
                case Boolean(this.filters.type === 'apartment' && !zoneName && this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt apartamente cu rate la dezvoltator disponibile în ' + cityName;
                    break;
                case Boolean(this.filters.type === 'house' && !zoneName && this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt case sau vile cu rate la dezvoltator disponibile în ' + cityName;
                    break;
                case Boolean(this.filters.type === 'commercial' && !zoneName && this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt spații comerciale cu rate la dezvoltator disponibile în ' + cityName;
                    break;
                case Boolean(!this.filters.type && zoneName && !this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt proiecte în ' + zoneName;
                    break;
                case Boolean(this.filters.type === 'apartment' && zoneName && !this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt apartamente disponibile in ' + zoneName;
                    break;
                case Boolean(this.filters.type === 'house' && zoneName && !this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt case sau vile disponibile în ' + zoneName;
                    break;
                case Boolean(this.filters.type === 'commercial' && zoneName && !this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt spații comerciale disponibile în ' + zoneName;
                    break;
                case Boolean(!this.filters.type && zoneName && this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt proiecte cu rate în ' + zoneName;
                    break;
                case Boolean(this.filters.type === 'apartment' && zoneName && this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt apartamente cu rate disponibile în ' + zoneName;
                    break;
                case Boolean(this.filters.type === 'house' && zoneName && this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt case sau vile cu rate disponibile în ' + zoneName;
                    break;
                case Boolean(this.filters.type === 'commercial' && zoneName && this.filters.ratesToDeveloper):
                    text = 'Momentan nu sunt spații comerciale cu rate disponibile în ' + zoneName;
                    break;
            }

            return text;
        },
        noResultsLinkText: function () {
            let cityName = this.filters.selectedCities[0] ? this.filters.selectedCities[0].name : 'oras';
            let zoneName = this.filters.selectedZones.length === 1 ? this.filters.selectedZones[0].name : null;

            let text = 'vezi toate proiectele din ' + cityName;

            switch(true) {
                case Boolean(this.filters.type === 'apartment' && !zoneName && !this.filters.ratesToDeveloper):
                    text = 'vezi toate proiectele din ' + cityName;
                    break;
                case Boolean(this.filters.type === 'house' && !zoneName && !this.filters.ratesToDeveloper):
                    text = 'vezi toate proiectele din ' + cityName;
                    break;
                case Boolean(this.filters.type === 'commercial' && !zoneName && !this.filters.ratesToDeveloper):
                    text = 'vezi toate proiectele din ' + cityName;
                    break;
                case Boolean(!this.filters.type && !zoneName && this.filters.ratesToDeveloper):
                    text = 'vezi toate proiectele din ' + cityName;
                    break;
                case Boolean(this.filters.type === 'apartment' && !zoneName && this.filters.ratesToDeveloper):
                    text = 'vezi toate apartamentele noi din ' + cityName;
                    break;
                case Boolean(this.filters.type === 'house' && !zoneName && this.filters.ratesToDeveloper):
                    text = 'vezi toate casele noi din ' + cityName;
                    break;
                case Boolean(this.filters.type === 'commercial' && !zoneName && this.filters.ratesToDeveloper):
                    text = 'vezi toate spațiile comerciale noi din ' + cityName;
                    break;
                case Boolean(!this.filters.type && zoneName && !this.filters.ratesToDeveloper):
                    text = 'vezi toate proiectele din ' + cityName;
                    break;
                case Boolean(this.filters.type === 'apartment' && zoneName && !this.filters.ratesToDeveloper):
                    text = 'vezi toate apartamentele din ' + cityName;
                    break;
                case Boolean(this.filters.type === 'house' && zoneName && !this.filters.ratesToDeveloper):
                    text = 'vezi toate casele din ' + cityName;
                    break;
                case Boolean(this.filters.type === 'commercial' && zoneName && !this.filters.ratesToDeveloper):
                    text = 'vezi toate spațiile din ' + cityName;
                    break;
                case Boolean(!this.filters.type && zoneName && this.filters.ratesToDeveloper):
                    text = 'vezi toate proiectele cu rate din ' + cityName;
                    break;
                case Boolean(this.filters.type === 'apartment' && zoneName && this.filters.ratesToDeveloper):
                    text = 'vezi toate apartamentele cu rate în ' + cityName;
                    break;
                case Boolean(this.filters.type === 'house' && zoneName && this.filters.ratesToDeveloper):
                    text = 'vezi toate casele cu rate în ' + cityName;
                    break;
                case Boolean(this.filters.type === 'commercial' && zoneName && this.filters.ratesToDeveloper):
                    text = 'vezi toate spațiile comerciale cu rate în ' + cityName;
                    break;
            }

            return text;
        },
        noResultsLinkUrl: function () {
            let citySlug = this.filters.selectedCities[0] ? this.filters.selectedCities[0].slug : '';
            let zoneSlug = this.filters.selectedZones.length === 1 ? this.filters.selectedZones[0].slug : null;
            let params = {orase: [citySlug]};

            switch(true) {
                case Boolean(this.filters.type === 'apartment' && !zoneSlug && this.filters.ratesToDeveloper):
                    params.tip = 'apartament';
                    break;
                case Boolean(this.filters.type === 'house' && !zoneSlug && this.filters.ratesToDeveloper):
                    params.tip = 'casa';
                    break;
                case Boolean(this.filters.type === 'commercial' && !zoneSlug && this.filters.ratesToDeveloper):
                    params.tip = 'spatiu';
                    break;
                case Boolean(this.filters.type === 'apartment' && zoneSlug && !this.filters.ratesToDeveloper):
                    params.tip = 'apartament';
                    break;
                case Boolean(this.filters.type === 'house' && zoneSlug && !this.filters.ratesToDeveloper):
                    params.tip = 'casa';
                    break;
                case Boolean(this.filters.type === 'commercial' && zoneSlug && !this.filters.ratesToDeveloper):
                    params.tip = 'spatiu';
                    break;
                case Boolean(!this.filters.type && zoneSlug && this.filters.ratesToDeveloper):
                    params.rtd = true;
                    break;
                case Boolean(this.filters.type === 'apartment' && zoneSlug && this.filters.ratesToDeveloper):
                    params.tip = 'apartament';
                    params.rtd = true;
                    break;
                case Boolean(this.filters.type === 'house' && zoneSlug && this.filters.ratesToDeveloper):
                    params.tip = 'casa';
                    params.rtd = true;
                    break;
                case Boolean(this.filters.type === 'commercial' && zoneSlug && this.filters.ratesToDeveloper):
                    params.tip = 'spatiu';
                    params.rtd = true;
                    break;
            }
            return window.getProjectListRelativeUrl(params);
        },
    },

    methods: {
        dropDown() {
             document.getElementById("myDropdown").classList.toggle("show");
        },

        hideFiltersMobile() {
            this.show = false;
        },
        changeSurfaceFilter(e) {
            const newMinVal = Math.ceil(e.unencoded[0]);
            const newMaxVal = Math.ceil(e.unencoded[1]);

            this.filters.minSurface = newMinVal > 0
                ? newMinVal
                : null;
            this.filters.maxSurface = newMaxVal < this.surfaceValuesMax
                ? newMaxVal
                : null;
            this.changeMinSurface();
            this.changeMaxSurface();
        },
        updateSurfaceDisplay(e) {
            var surfaceDisplay = document.querySelector("#filter-surface-display");
            var minSurface = Math.ceil(e.unencoded[0]);
            var maxSurface = Math.ceil(e.unencoded[1]);
            surfaceDisplay.innerHTML = `${minSurface} &#13217;- ${maxSurface} &#13217;`;
        },
        changePriceFilter(e) {
            const newMinVal = Math.ceil(e.unencoded[0]);
            const newMaxVal = Math.ceil(e.unencoded[1]);
            this.filters.minPrice = newMinVal > 0
                ? newMinVal
                : null;
            this.filters.maxPrice = newMaxVal < this.priceValuesMax
                ? newMaxVal
                : null;
            this.changeMinPrice();
            this.changeMaxPrice();
        },
        updatePriceDisplay(e) {
            var priceDisplay = document.querySelector("#filter-price-display");
            var minPrice = Math.ceil(e.unencoded[0]);
            var maxPrice = Math.ceil(e.unencoded[1]);
            priceDisplay.innerHTML = `${minPrice} &#128; - ${maxPrice} &#128;`;
        },
        closeRoomsResults() {
            let roomResultBox = document.getElementById("roomSearchResultBox");
            roomResultBox.style.display = "none";
        },

        roomsSearchTrigger() {
            let roomResultBox = document.getElementById("roomSearchResultBox");
            let roomsTagList = document.getElementById("roomstagList");
            roomResultBox.style.display = "block";
            roomsTagList.style.display = "flex";
        },
        setActiveDropdown(index) {
            this.activeIndex = index;
        },
        minPriceTrigger() {
            let minPriceResults = document.getElementById("minPriceResults");
            minPriceResults.style.display = "block";
        },
        maxPriceTrigger() {
            let maxPriceResults = document.getElementById("maxPriceResults");
            maxPriceResults.style.display = "block";
        },
        minSurfaceTrigger() {
            let minSurfaceResults = document.getElementById("minSurfaceResults");
            minSurfaceResults.style.display = "block";
        },
        maxSurfaceTrigger() {
            let maxSurfaceResults = document.getElementById("maxSurfaceResults");
            maxSurfaceResults.style.display = "block";
        },

        closeProjectResults() {
            let projectSearchResultBox = document.getElementById(
                "projectsSearchResultBox"
            );
            projectSearchResultBox.style.display = "none";
            this.resetProjectName();
        },

        projectSearchTrigger() {
            let projectSearchResultBox = document.getElementById(
                "projectsSearchResultBox"
            );
            projectSearchResultBox.style.display = "block";
        },

        closeCitiesResults(screenSize) {
            screenSize = screenSize.charAt(0).toUpperCase() + screenSize.slice(1);
            let cityResultBox = document.getElementById(`citySearchResultBox${screenSize}`);
            cityResultBox.style.display = "none";
        },

        citiesSearchTrigger(screenSize) {
            screenSize = screenSize.charAt(0).toUpperCase() + screenSize.slice(1);
            let cityResultBox = document.getElementById(`citySearchResultBox${screenSize}`);
            let citiesTagList = document.getElementById("citiestagList");
            cityResultBox.style.display = "block";
            citiesTagList.style.display = "flex";
        },

        closeZonesResults(screenSize) {
            screenSize = screenSize.charAt(0).toUpperCase() + screenSize.slice(1);
            let areaResultBox = document.getElementById(`areaResultBox${screenSize}`);
            if(areaResultBox)
                areaResultBox.style.display = "none";
        },
        zonesSearchTrigger(screenSize) {
            screenSize = screenSize.charAt(0).toUpperCase() + screenSize.slice(1);
            let areaResultBox = document.getElementById(`areaResultBox${screenSize}`);
            let areatagList = document.getElementById("areatagList");
            if(areaResultBox)
                areaResultBox.style.display = "block";
            if(areatagList)
                areatagList.style.display = "flex";
        },
        getProjectName(project) {
            let name =
                project.name + ", " + project.county.name + ", " + project.city.name;
            if (project.zone) {
                name += ", " + project.zone.name;
            }
            if (project.subzone) {
                name += ", " + project.subzone.name;
            }
            return name;
        },
        getProjectLocation(project) {
            let location = [];
            if (project.county) {
                location.push(project.county.name);
            }
            if (project.city) {
                location.push(project.city.name);
            }
            if (project.zone) {
                location.push(project.zone.name);
            }
            if (project.subzone) {
                location.push(project.subzone.name);
            }
            return location.join(', ');
        },
        activateLoadingFilters() {
            this.showLoadingFilters = true;
// $('.skeleton-loading').children().hide();
        },
        async deleteRoomCount(roomDel) {
            for (let i = 0; i < this.filters.selectedRoomsCount.length; i++) {
                if (this.filters.selectedRoomsCount[i].id === roomDel.id) {
                    this.filters.selectedRoomsCount.splice(i, 1);
                    this.changeRoomsCount();
                }
            }
            await this.fetchProjects();
        },
        deleteCity(cityDel) {
            for (let i = 0; i < this.filters.selectedCities.length; i++) {
                if (this.filters.selectedCities[i].id === cityDel.id) {
                    this.filters.selectedCities.splice(i, 1);
                    this.changeCities();
                }
            }
        },
        async deleteZone(zoneDel) {
            for (let i = 0; i < this.filters.selectedZones.length; i++) {
                if (this.filters.selectedZones[i].id === zoneDel.id) {
                    this.filters.selectedZones.splice(i, 1);
                    this.changeZones();
                }
            }
        },
        async deleteMobileFilterType(){
            this.filters.type = null;

            this.changeType();
        },
        async deleteMobileFilterPrice(){
            this.filters.minPrice = null;
            this.filters.maxPrice = null;
            $("input[name='min_price']").prop("checked", false);
            $("input[name='max_price']").prop("checked", false);

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {
                min_price: this.filters.minPrice,
                max_price: this.filters.maxPrice,
            });

            this.updateQueryStringParam();
            this.fetchProjects();

        },
        async deleteMobileFilterSurface(){
            this.filters.minSurface = null;
            this.filters.maxSurface = null;
            $("input[name='min_surface']").prop("checked", false);
            $("input[name='max_surface']").prop("checked", false);

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {
                min_surface: this.filters.minSurface,
                max_surface: this.filters.maxSurface,
            });

            this.updateQueryStringParam();
            this.fetchProjects();
        },
        async deleteMobileFilterRatesToDeveloper(){
            this.filters.ratesToDeveloper = null;
            this.changeRatesToDeveloper();
        },
       
         async resetSort(){
            
            this.sortBy="";
        },
        resetFilters() {
            this.filters.selectedRoomsCount = [];
            // this.filters.selectedCities = [];
            this.filters.selectedCities = [this.selectedCounty.cities[0]];
            this.filters.selectedZones = [];
            this.filters.selectedSubzones = [];
            this.filters.minPrice = null;
            this.filters.maxPrice = null;
            this.filters.minSurface = null;
            this.filters.maxSurface = null;
            this.filters.type = null;
            this.filters.ratesToDeveloper = null;
            $("input[name='min_surface']").prop("checked", false);
            $("input[name='max_surface']").prop("checked", false);
            $("input[name='min_price']").prop("checked", false);
            $("input[name='max_price']").prop("checked", false);

            // preserve reactivity
            this.urlParams = {
                orase: [this.filters.selectedCities[0].slug]
            };

            this.selectedRoomsCountInactive = [];
            this.updateQueryStringParam();
            this.fetchProjects();
            this.setCenterMap();
        },
        async changeCities(fetchPr = true) {
            let vm = this;

            let previouslySelectedZoneSlugs = [];
            this.filters.selectedZones.forEach(function (zone) {
                previouslySelectedZoneSlugs.push(zone.slug);
            });

            this.filters.selectedZones = this.filters.selectedSubzones = this.zones = [];
            if (this.filters.selectedCities) {
                this.filters.selectedCities.forEach(function (city) {
                    vm.zones = vm.zones.concat(city.zones);
                });
                this.filters.selectedZones = this.zones.filter((zone) => {
                    return previouslySelectedZoneSlugs.includes(zone.slug);
                });
            }

            let citySlugs = [];
            this.filters.selectedCities.forEach(function (city) {
                citySlugs.push(city.slug);
            });

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {orase: citySlugs});

            this.updateQueryStringParam();

            if (fetchPr) {
                await this.fetchProjects();
            }
            this.setCenterMap();
        },
        changeZones() {
            let vm = this;
            let zoneSlugs = [];
            this.filters.selectedZones.forEach(function (zone) {
                zoneSlugs.push(zone.slug);
            });
            this.filters.selectedSubzones.forEach(function (tempsubzone, key) {
                const found = vm.filters.selectedZones.find(
                    (zone) => (zone.id = tempsubzone.zone_id)
                );
                if (!found) {
                    vm.filters.selectedSubzones.splice(key, 1);
                }
            });

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {zone: zoneSlugs});

            this.changeSubzones();
            this.updateQueryStringParam();
            this.fetchProjects();
        },
        changeSubzones() {
            let vm = this;
            let tempsubzones = [];
            this.filters.selectedSubzones.forEach(function (tempsubzone) {
                tempsubzones.push(tempsubzone.id);
                const found = vm.filters.selectedZones.find(
                    (zone) => (zone.id = tempsubzone.zone_id)
                );
                if (!found) {
                    let tempzone = vm.zones.filter((zone) => {
                        return zone.id == tempsubzone.zone_id;
                    });
                    if (tempzone && tempzone.length > 0) {
                        vm.filters.selectedZones.push(tempzone[0]);
                    }
                }
            });

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {subzone: tempsubzones});

            this.updateQueryStringParam();
            this.fetchProjects();
        },
        changeProjectName() {},
        changeRoomsCount(fetchPr = true) {
            let roomsCount = null;
            if (
                this.filters.selectedRoomsCount &&
                this.filters.selectedRoomsCount.length > 0
            ) {
                roomsCount = [];
                this.filters.selectedRoomsCount.forEach((roomCount) => {
                    roomsCount.push(roomCount.id);
                });
            }

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {rooms_count: roomsCount});

            this.updateQueryStringParam();
            if (fetchPr) {
                this.fetchProjects();
            }
        },
        changeType() {
            let roomsCount = this.urlParams.rooms_count;
            if (this.isFilterCommercial) {
                if (this.filters.selectedRoomsCount.length) {
                    this.selectedRoomsCountInactive = [...this.filters.selectedRoomsCount];
                }
                this.filters.selectedRoomsCount = [];
                roomsCount = null;
            }
            else if (this.selectedRoomsCountInactive.length) {
                this.filters.selectedRoomsCount = [...this.selectedRoomsCountInactive];
                roomsCount = [];
                this.selectedRoomsCountInactive.forEach((roomCount) => {
                    roomsCount.push(roomCount.id);
                });
                this.selectedRoomsCountInactive = [];
            }

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {type: this.filters.type, rooms_count: roomsCount});

            this.updateQueryStringParam();
            this.fetchProjects();
        },
        changeMinSurface() {
            let minSurface = this.filters.minSurface && this.filters.minSurface > 0
                ? this.filters.minSurface
                : null;

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {min_surface: minSurface});

            this.updateQueryStringParam();
            this.fetchProjects();
        },
        changeMaxSurface() {
            let maxSurface = this.filters.maxSurface && this.filters.maxSurface > 0
                ? this.filters.maxSurface
                : null;

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {max_surface: maxSurface});

            this.updateQueryStringParam();
            this.fetchProjects();
        },
        changeMaxPrice() {
            let maxPrice = this.filters.maxPrice && this.filters.maxPrice > 0
                ? this.filters.maxPrice
                : null;

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {max_price: maxPrice});
            
            this.updateQueryStringParam();
            this.fetchProjects();
        },
        changeMinPrice() {
            let minPrice = this.filters.minPrice && this.filters.minPrice > 0
                ? this.filters.minPrice
                : null;

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {min_price: minPrice});

            this.updateQueryStringParam();
            this.fetchProjects();
        },
        changeSort() {
            let sortBy = this.sortBy && this.sortBy != ""
                ? this.sortBy
                : null;

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {sort_by: sortBy});

            this.updateQueryStringParam();
            this.fetchProjects();
        },
        async changeRatesToDeveloper() {
            let ratesToDeveloper = this.filters.ratesToDeveloper && this.filters.ratesToDeveloper == 1
                ? 1
                : null;

            // fix - preserve reactivity
            this.filters.ratesToDeveloper = ratesToDeveloper;

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {rtd: ratesToDeveloper});

            this.updateQueryStringParam();
            await this.fetchProjects();
        },
        handlePaginationClick(event) {
            // Prevent the default link behavior
            event.preventDefault();

            let link = event.target.closest('a');
            let page = link.getAttribute('data-page');
            page = parseInt(page);

            if (isNaN(page)) {
                return;
            }

            // Execute your desired method
            this.fetchProjects(page);

            $('html, body').animate({
                scrollTop: $(".search-row .section-title").offset().top - $('header.header').outerHeight() - 10
            }, 1500);
        },
        handleModelsPaginationClick(event) {
            // Prevent the default link behavior
            event.preventDefault();

            let link = event.target.closest('a');
            let page = link.getAttribute('data-page');
            page = parseInt(page);

            if (isNaN(page)) {
                return;
            }

            // Execute your desired method
            this.fetchModels(page);

            $('html, body').animate({
                scrollTop: $(".search-row .section-title").offset().top - $('header.header').outerHeight() - 10
            }, 1500);
        },
        async fetchProjects(page = 1) {
            let vm = this;
            this.activateLoadingFilters();
            let params = await this.buildParams();

            params["page"] = page;

            await window.axios
                .get("/ajax/search-projects", {
                    params: Object.assign({}, params),
                })
                .then(function (response) {
                    vm.projects = response.data.data.projects;

                    // preserve reactivity
                    let urlParams = Object.assign({}, vm.urlParams, {page: page});
                    if (urlParams.page <= 1) {
                        delete urlParams.page;
                    }
                    vm.urlParams = urlParams;

                    vm.updateQueryStringParam();
                    vm.totalFilteredProjects = response.data.data.totalFilteredProjects;
                    vm.totalProjects = response.data.data.totalProjects;
                    vm.paginationLinks = response.data.data.paginationLinks;
                    vm.showLoadingFilters = false;

                    vm.fetchMapProjects(vm.totalFilteredProjects);
                    vm.fetchModels();
                })
                .catch(function () {
                    vm.showLoadingFilters = false;
                });
        },
        async fetchMapProjects(fetch) {
            let vm = this;
            let params = await this.buildParams();
            params["skip"] = 0;
            params["limit"] = fetch;

            this.$refs.prOnMaps.infoWinOpen = false;

            await window.axios
                .get("/ajax/search-projects", {
                    params: Object.assign({}, params),
                })
                .then(function (response) {
                    vm.mapProjects = response.data.data.projects;
                })
                .catch(function () {
                });
        },
        async fetchModels(page = 1) {
            let vm = this;
            this.activateLoadingFilters();
            let params = await this.buildParams();
            params["page"] = page;

            await window.axios
                .get("/ajax/search-models", {
                    params: Object.assign({}, params),
                })
                .then(function (response) {
                    vm.projectModels = response.data.data.models;

                    vm.totalFilteredModels = response.data.data.totalFilteredModels;
                    vm.totalAvailableItems = response.data.data.totalAvailableItems;
                    vm.modelsPaginationLinks = response.data.data.paginationLinks;
                    vm.showLoadingFilters = false;
                })
                .catch(function () {
                    vm.showLoadingFilters = false;
                });
        },
        buildParams() {
            let params = [];
            params["county"] = this.county.id;
            for (let name in this.filters) {
                switch (name) {
                    case "type":
                        if (this.filters[name]) {
                            params["type"] = this.filters[name];
                        }
                        break;

                    case "selectedRoomsCount":
                        if (this.filters[name].length > 0) {
                            params["rooms_count"] = [];
                            this.filters.selectedRoomsCount.forEach(function (roomCount) {
                                params["rooms_count"].push(roomCount.id);
                            });
                        }
                        break;

                    case "selectedCities":
                        if (this.filters[name].length > 0) {
                            params["city"] = [];
                            this.filters.selectedCities.forEach(function (city) {
                                params["city"].push(city.id);
                            });
                        }
                        break;

                    case "selectedZones":
                        if (this.filters[name].length > 0) {
                            params["zone"] = [];
                            this.filters.selectedZones.forEach(function (zone) {
                                params["zone"].push(zone.id);
                            });
                        }
                        break;

                    case "selectedSubzones":
                        if (this.filters[name].length > 0) {
                            params["subzone"] = [];
                            this.filters.selectedSubzones.forEach(function (subzone) {
                                params["subzone"].push(subzone.id);
                            });
                        }
                        break;

                    case "minSurface":
                        if (this.filters[name]) {
                            params["min_surface"] = this.filters[name];
                        }
                        break;

                    case "maxSurface":
                        if (this.filters[name]) {
                            params["max_surface"] = this.filters[name];
                        }
                        break;

                    case "minPrice":
                        if (this.filters[name]) {
                            params["min_price"] = this.filters[name];
                        }
                        break;

                    case "maxPrice":
                        if (this.filters[name]) {
                            params["max_price"] = this.filters[name];
                        }
                        break;

                    case "ratesToDeveloper":
                        if (this.filters[name] && this.filters[name] == 1) {
                            params["rtd"] = 1;
                        }
                        break;
                }
            }
            if (this.sortBy && this.sortBy != "") {
                params["sort_by"] = this.sortBy;
            }
            return params;
        },
        applyUrlFilters() {
            let vm = this;
            const params = this.getUrlParamsFromQueryParams();
            let page = 1;
            if (params.rooms_count) {
                if (Array.isArray(params.rooms_count)) {
                    params.rooms_count = params.rooms_count.map(function (item) {
                        return parseInt(item, 10);
                    });
                } else {
                    params.rooms_count = parseInt(params.rooms_count, 10);
                }
                this.filters.selectedRoomsCount = this.roomsCount.filter(
                    (roomCount) => {
                        if (Array.isArray(params.rooms_count)) {
                            return params.rooms_count.includes(roomCount.id);
                        } else {
                            return params.rooms_count === roomCount.id;
                        }
                    }
                );
                this.roomsSearchTrigger();
                this.closeRoomsResults();
                this.changeRoomsCount(false);
            }

            if (params.orase) {
                params.orase = params.orase.split('_').filter(value => $.trim(value));
            } else {
                params.orase = [...vm.preSelectedCitySlugList];
            }
            if (params.orase) {
                this.filters.selectedCities = this.selectedCounty.cities.filter(
                    (city) => {
                        return params.orase.includes(city.slug);
                    }
                );
                this.citiesSearchTrigger('mobile');
                this.citiesSearchTrigger('desktop');
                this.closeCitiesResults('mobile');
                this.closeCitiesResults('desktop');
                this.changeCities(false);
            }

            if (params.zone) {
                params.zone = params.zone.split('_').filter(value => $.trim(value));
            } else {
                params.zone = [...vm.preSelectedZoneSlugList];
            }
            if (params.zone) {
                this.filters.selectedZones = this.zones.filter((zone) => {
                    return params.zone.includes(zone.slug);
                });
                this.zonesSearchTrigger('mobile');
                this.zonesSearchTrigger('desktop');
                this.closeZonesResults('mobile');
                this.closeZonesResults('desktop');
            }

            if (params.subzone) {
                if (Array.isArray(params.subzone)) {
                    params.subzone = params.subzone.map(function (item) {
                        return parseInt(item, 10);
                    });
                } else {
                    params.subzone = parseInt(params.subzone, 10);
                }
                this.filters.selectedSubzones = [];
                this.filters.selectedZones.forEach(function (zone) {
                    let subz = zone.subzones.filter((subzone) => {
                        if (Array.isArray(params.subzone)) {
                            return params.subzone.includes(subzone.id);
                        } else {
                            return params.subzone === subzone.id;
                        }
                    });
                    vm.filters.selectedSubzones = vm.filters.selectedSubzones.concat(
                        subz
                    );
                });

                this.zonesSearchTrigger('mobile');
                this.zonesSearchTrigger('desktop');
                this.closeZonesResults('mobile');
                this.closeZonesResults('desktop');
            }

            if (!params.type) {
                params.type = vm.preSelectedType;
            }
            if (params.type !== '') {
                this.filters.type = params.type;
            }

            if (
                params.min_surface &&
                params.min_surface != "" &&
                params.min_surface > 0
            ) {
                this.filters.minSurface = params.min_surface;
            }
            if (
                params.max_surface &&
                params.max_surface != "" &&
                params.max_surface > 0
            ) {
                this.filters.maxSurface = params.max_surface;
            }
            if (params.min_price && params.min_price != "" && params.min_price > 0) {
                this.filters.minPrice = params.min_price;
            }
            if (params.max_price && params.max_price != "" && params.max_price > 0) {
                this.filters.maxPrice = params.max_price;
            }
            if (params.sort_by && params.sort_by != "") {
                this.sortBy = params.sort_by;
            }

            if (!params.rtd) {
                params.rtd = vm.preSelectedRtd;
            }
            if (params.rtd) {
                this.filters.ratesToDeveloper = 1;
            }

            if (params.page && params.page != "" && params.page > 0) {
                page = params.page;
            }
            if (params.layout && params.layout != "" && params.layout > 0) {
                this.layoutChange = isNaN(parseInt(params.layout)) ? this.LAYOUT_MODE_CARD : parseInt(params.layout);
            }

            // preserve reactivity
            this.urlParams = params;

            this.fetchProjects(page);
            this.updateQueryStringParam();
        },
        updateQueryStringParam() {
            let filtered = Object.entries(this.queryParams).reduce(
                (a, [k, v]) => (v ? ((a[k] = v), a) : a),
                {}
            );

            let url = [
                location.protocol,
                "//",
                location.host,
                window.getProjectListRelativeUrl(filtered),
            ].join("");

            window.history.replaceState({}, "", url);

            // update meta tags robots & canonical url
            let parsedUrl = new URL(url);
            let page = parseInt(parsedUrl.searchParams.get('page'));

            let seoCanIndex = parsedUrl.searchParams.size === 0 || (parsedUrl.searchParams.size === 1 && parsedUrl.searchParams.has('page'));
            let seoCanonicalUrl = seoCanIndex && page > 1 ? url : parsedUrl.origin + parsedUrl.pathname;

            document.getElementById('seoMetaRobots')
                .setAttribute('content', (seoCanIndex ? 'index' : 'noindex') + ', follow');
            document.getElementById('seoMetaCanonicalUrl')
                .setAttribute('href', seoCanonicalUrl);
        },
        setCenterMap() {
            if (this.filters.selectedCities.length > 0) {
                this.$refs.prOnMaps.lat = parseFloat(
                    this.filters.selectedCities[0].latitude
                );
                this.$refs.prOnMaps.lng = parseFloat(
                    this.filters.selectedCities[0].longitude
                );
                if (this.filters.selectedCities.length === 1) {
                    this.$refs.prOnMaps.zoom = 13;
                } else {
                    this.$refs.prOnMaps.zoom = 9;
                }
            } else {
                let city = this.county.cities[0];
                this.$refs.prOnMaps.lat = parseFloat(city.latitude);
                this.$refs.prOnMaps.lng = parseFloat(city.longitude);
                this.$refs.prOnMaps.zoom = 9;
            }
        },
        checkNewFlag(project) {
            let createDate = window.moment(project.created_at);
            let now = window.moment();
            let diff = window.moment.duration(now.diff(createDate));
            return diff.asDays() <= 30;
        },
        checkFavoriteProject(project) {
            if (this.favorites && this.favorites.length > 0) {
                let exists = this.favorites.filter(
                    (favorite) =>
                        favorite.favoritable_type == "App\\Project" &&
                        favorite.favoritable_id === project.id
                );
                return exists.length > 0;
            } else {
                return false;
            }
        },
        checkFavoriteModel(model) {
            if (this.favorites && this.favorites.length > 0) {
                let exists = this.favorites.filter(
                    (favorite) =>
                        favorite.favoritable_type == "App\\ProjectModel" &&
                        favorite.favoritable_id === model.id
                );
                return exists.length > 0;
            } else {
                return false;
            }
        },
        deleteFavoriteProject(id) {
            let vm = this;
            window.Swal.fire({
                title: "Esti sigur?",
                text:
                    "Daca stergeti acest proiect vor fi sterse de la favorite si modelele din acest proiect!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Da, sterge!",
                cancelButtonText: "Nu, anuleaza.",
            }).then((result) => {
                if (result.value) {
                    if(vm.defFavorites) { // logged in
                        window.axios
                            .delete(`/ajax/favorites/${id}/project`)
                            .then(function () {
                                vm.favorites.forEach(function (fav, key) {
                                    if (
                                        fav.favoritable_type === "App\\Project" &&
                                        fav.favoritable_id === id
                                    ) {
                                        vm.favorites.splice(key, 1);
                                    }
                                });
                                window.Swal.fire({
                                    position: "top-end",
                                    icon: "success",
                                    html: "Proiectul a fost sters din lista de favorite.",
                                    showConfirmButton: false,
                                    timer: 1500,
                                });
                            })
                            .catch(function (err) {
                                window.showError(err);
                            });
                    } else {
                        vm.favorites = vm.favorites.filter(
                            fav => !(
                                (
                                    fav.favoritable_type === "App\\Project" &&
                                    fav.favoritable_id === id
                                ) || (
                                    fav.favoritable_type === "App\\ProjectModel" &&
                                    fav.projectId === id
                                )
                            )
                        );
                        window.saveLocalFavorites(vm.favorites);

                        window.Swal.fire({
                            position: "top-end",
                            icon: "success",
                            html: "Proiectul a fost sters din lista de favorite.",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }
                }
            });
        },
        deleteFavoriteModel(id) {
            let vm = this;
            if(vm.defFavorites) { // logged in
                window.axios.delete(`/ajax/favorites/${id}/model`)
                    .then(function () {
                        vm.favorites.forEach(function (fav, key) {
                            if (fav.favoritable_type === 'App\\ProjectModel' && fav.favoritable_id === id) {
                                vm.favorites.splice(key, 1);
                            }
                        });
                        window.Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            html: 'Modelul a fost sters din lista de favorite.',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    })
                    .catch(function (err) {
                        window.showError(err)
                    });
            } else {
                vm.favorites = vm.favorites.filter(
                    fav => !(
                        fav.favoritable_type === "App\\ProjectModel" &&
                        fav.favoritable_id === id
                    )
                );
                window.saveLocalFavorites(vm.favorites);

                window.Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    html: 'Modelul a fost sters din lista de favorite.',
                    showConfirmButton: false,
                    timer: 1500
                });
            }
        },
        resetProjectName() {
            this.projectNameSearch = '';
        },
        changeLayout(layout) {
            this.layoutChange = isNaN(parseInt(layout)) ? this.LAYOUT_MODE_CARD : parseInt(layout);

            // preserve reactivity
            this.urlParams = Object.assign({}, this.urlParams, {layout: layout});

            this.updateQueryStringParam();
        },
        async fetchLatestDeveloperNewsCount() {
            let vm = this;
            let params = {}
            if (window.getLocalLastDeveloperNewsTimestamp()) {
                params['since'] = window.getLocalLastDeveloperNewsTimestamp();
            }

            await window.axios
                .get(`/ajax/newsfeed/${vm.county.id}/latest-developer-news-count`, {
                    params: Object.assign({}, params),
                })
                .then(function (response) {
                    vm.latestDeveloperNewsCount = isNaN(parseInt(response.data.data.count))
                        ? 0
                        : parseInt(response.data.data.count);
                })
                .catch(function () {
                });
        },
        getUrlParamsFromQueryParams: function () {
            let params = window.getAllUrlParams();

            if (Object.prototype.hasOwnProperty.call(params, 'camere')) {
                params.rooms_count = params.camere;
                delete params.camere;
            }
            if (Object.prototype.hasOwnProperty.call(params, 'suprafata_min')) {
                params.min_surface = params.suprafata_min;
                delete params.suprafata_min;
            }
            if (Object.prototype.hasOwnProperty.call(params, 'suprafata_max')) {
                params.max_surface = params.suprafata_max;
                delete params.suprafata_max;
            }
            if (Object.prototype.hasOwnProperty.call(params, 'pret_min')) {
                params.min_price = params.pret_min;
                delete params.pret_min;
            }
            if (Object.prototype.hasOwnProperty.call(params, 'pret_max')) {
                params.max_price = params.pret_max;
                delete params.pret_max;
            }
            if (Object.prototype.hasOwnProperty.call(params, 'tip')) {
                switch (params.tip) {
                    case 'apartament':
                        params.type = 'apartment';
                        break;
                    case 'casa':
                        params.type = 'house';
                        break;
                    case 'spatiu':
                        params.type = 'commercial';
                        break;
                    default:
                        params.type = params.tip;
                }
                delete params.tip;
            }

            return params;
        },
        getQueryParamsFromUrlParams: function () {
            return this.queryParams;
        },
        storeProjectUrlParamsInLocalStorage: function () {
            localStorage.setItem("projectUrlParams", JSON.stringify(this.projectUrlParams));
        },
    },
    watch: {
        show: function() {
            if(this.show)
            {
                document.body.style.position = 'fixed';
                document.body.style.top = `-${window.scrollY}px`;
            }
            else
            {
                document.body.style.position = '';
                document.body.style.top = '';
            }
        },
        'filters.selectedCities': function() {
            let cities = [];
            this.filters.selectedCities.forEach(function (city) {
                cities.push(city.slug);
            });

            let generalNewsfeedButton = document.getElementById("generalNewsfeed");
            generalNewsfeedButton.setAttribute('href', window.getProjectNewsfeedRelativeUrl(cities));
        },
    }
};
</script>


<style scoped>
    .listingBtn {
        display: inline-block;
        cursor: pointer;
        padding-bottom: 5px;
    }
    .listingBtn.active {
        border-bottom: 3px solid #6771e2;
    }

    .pp-model-item .element-header .element-info .element-location p {
        font-size: 13px;
        color: #7d7d84;
        display: inline-block;
    }

    .pp-model-item .element-header {
        padding-top: 10px;
    }

    .pp-model-item .pp-length-flex {
        padding-top: 10px;
    }

    .pp-model-item .vat {
        font-size: 10px;
        vertical-align: text-top;
    }

    @media (max-width: 575px) {
        .pp-model-item .xs-flex-full-width {
            flex: 0 0 100%;
        }
        .pp-model-item .pp-model-item-content .pp-model-info .pp-model-info-strip ul {
            display: block !important;
        }
    }

    @media (max-width: 991px) {
        .pp-model-item {
            margin-bottom: 0;
        }
    }

    .pp-model-item .pp-avb-item {
        padding: 3px 40px !important;
        font-weight: normal !important;
    }
    @media (max-width: 576px) {
        .pp-model-item .pp-avb-item {
            padding: 3px 12px !important;
        }
    }

    .dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #f1f1f1;
        min-width: 160px;
        overflow: auto;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        z-index: 1;
    }

    .show {display: block;}
</style>